// /////////////////////////////////////////////////////////////////////
//
//
// (C) Copyright 2023 Autodesk, Inc. All rights reserved.
//
//                     ****  CONFIDENTIAL MATERIAL  ****
//
// The information contained herein is confidential, proprietary to
// Autodesk, Inc., and considered a trade secret.  Use of this information
// by anyone other than authorized employees of Autodesk, Inc. is granted
// only under a written nondisclosure agreement, expressly prescribing the
// the scope and manner of such use.
//
// /////////////////////////////////////////////////////////////////////

//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */

// ReSharper disable InconsistentNaming


export abstract class AuthDataBaseOfCustomerUser implements IAuthDataBaseOfCustomerUser {
  userId?: string;
  user?: CustomerUser | undefined;
  authTokenExpiry?: Date;
  adskAccessToken?: string;
  refreshToken?: string;
  refreshTokenExpiry?: Date;
  scope?: string;

  constructor(data?: IAuthDataBaseOfCustomerUser) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data["userId"];
      this.user = _data["user"] ? CustomerUser.fromJS(_data["user"]) : undefined as any;
      this.authTokenExpiry = _data["authTokenExpiry"] ? new Date(_data["authTokenExpiry"].toString()) : undefined as any;
      this.adskAccessToken = _data["adskAccessToken"];
      this.refreshToken = _data["refreshToken"];
      this.refreshTokenExpiry = _data["refreshTokenExpiry"] ? new Date(_data["refreshTokenExpiry"].toString()) : undefined as any;
      this.scope = _data["scope"];
    }
  }

  static fromJS(data: any): AuthDataBaseOfCustomerUser {
    data = typeof data === 'object' ? data : {};
    throw new Error("The abstract class 'AuthDataBaseOfCustomerUser' cannot be instantiated.");
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["userId"] = this.userId;
    data["user"] = this.user ? this.user.toJSON() : undefined as any;
    data["authTokenExpiry"] = this.authTokenExpiry ? this.authTokenExpiry.toISOString() : undefined as any;
    data["adskAccessToken"] = this.adskAccessToken;
    data["refreshToken"] = this.refreshToken;
    data["refreshTokenExpiry"] = this.refreshTokenExpiry ? this.refreshTokenExpiry.toISOString() : undefined as any;
    data["scope"] = this.scope;
    return data;
  }
}

export interface IAuthDataBaseOfCustomerUser {
  userId?: string;
  user?: CustomerUser | undefined;
  authTokenExpiry?: Date;
  adskAccessToken?: string;
  refreshToken?: string;
  refreshTokenExpiry?: Date;
  scope?: string;
}

export class AuthDataOfCustomerUser extends AuthDataBaseOfCustomerUser implements IAuthDataOfCustomerUser {
  authToken?: string;

  constructor(data?: IAuthDataOfCustomerUser) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.authToken = _data["authToken"];
    }
  }

  static override fromJS(data: any): AuthDataOfCustomerUser {
    data = typeof data === 'object' ? data : {};
    let result = new AuthDataOfCustomerUser();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["authToken"] = this.authToken;
    super.toJSON(data);
    return data;
  }
}

export interface IAuthDataOfCustomerUser extends IAuthDataBaseOfCustomerUser {
  authToken?: string;
}

export class DeckardAuthData extends AuthDataOfCustomerUser implements IDeckardAuthData {

  constructor(data?: IDeckardAuthData) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): DeckardAuthData {
    data = typeof data === 'object' ? data : {};
    let result = new DeckardAuthData();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IDeckardAuthData extends IAuthDataOfCustomerUser {
}

export class UserBase implements IUserBase {
  id?: string;
  username?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  isEmailVerified?: boolean;
  is2FAEnabled?: boolean;
  language?: string;
  countryCode?: string;
  profileImages?: UserProfileImages;

  constructor(data?: IUserBase) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.username = _data["username"];
      this.email = _data["email"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.isEmailVerified = _data["isEmailVerified"];
      this.is2FAEnabled = _data["is2FAEnabled"];
      this.language = _data["language"];
      this.countryCode = _data["countryCode"];
      this.profileImages = _data["profileImages"] ? UserProfileImages.fromJS(_data["profileImages"]) : undefined as any;
    }
  }

  static fromJS(data: any): UserBase {
    data = typeof data === 'object' ? data : {};
    let result = new UserBase();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["username"] = this.username;
    data["email"] = this.email;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["isEmailVerified"] = this.isEmailVerified;
    data["is2FAEnabled"] = this.is2FAEnabled;
    data["language"] = this.language;
    data["countryCode"] = this.countryCode;
    data["profileImages"] = this.profileImages ? this.profileImages.toJSON() : undefined as any;
    return data;
  }
}

export interface IUserBase {
  id?: string;
  username?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  isEmailVerified?: boolean;
  is2FAEnabled?: boolean;
  language?: string;
  countryCode?: string;
  profileImages?: UserProfileImages;
}

export class CustomerUser extends UserBase implements ICustomerUser {
  customer?: CustomerInfo;
  isAdmin?: boolean;
  roles?: string[];

  constructor(data?: ICustomerUser) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.customer = _data["customer"] ? CustomerInfo.fromJS(_data["customer"]) : undefined as any;
      this.isAdmin = _data["isAdmin"];
      if (Array.isArray(_data["roles"])) {
        this.roles = [] as any;
        for (let item of _data["roles"])
          this.roles!.push(item);
      }
    }
  }

  static override fromJS(data: any): CustomerUser {
    data = typeof data === 'object' ? data : {};
    let result = new CustomerUser();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
    data["isAdmin"] = this.isAdmin;
    if (Array.isArray(this.roles)) {
      data["roles"] = [];
      for (let item of this.roles)
        data["roles"].push(item);
    }
    super.toJSON(data);
    return data;
  }
}

export interface ICustomerUser extends IUserBase {
  customer?: CustomerInfo;
  isAdmin?: boolean;
  roles?: string[];
}

export class CustomerInfo implements ICustomerInfo {
  id?: string;
  name?: string;
  emailDomain?: string;
  validEmails?: string[];
  allowAllUsers?: boolean;

  constructor(data?: ICustomerInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.emailDomain = _data["emailDomain"];
      if (Array.isArray(_data["validEmails"])) {
        this.validEmails = [] as any;
        for (let item of _data["validEmails"])
          this.validEmails!.push(item);
      }
      this.allowAllUsers = _data["allowAllUsers"];
    }
  }

  static fromJS(data: any): CustomerInfo {
    data = typeof data === 'object' ? data : {};
    let result = new CustomerInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["emailDomain"] = this.emailDomain;
    if (Array.isArray(this.validEmails)) {
      data["validEmails"] = [];
      for (let item of this.validEmails)
        data["validEmails"].push(item);
    }
    data["allowAllUsers"] = this.allowAllUsers;
    return data;
  }
}

export interface ICustomerInfo {
  id?: string;
  name?: string;
  emailDomain?: string;
  validEmails?: string[];
  allowAllUsers?: boolean;
}

export class UserProfileImages implements IUserProfileImages {
  sizeX20?: string | undefined;
  sizeX40?: string | undefined;
  sizeX50?: string | undefined;
  sizeX58?: string | undefined;
  sizeX80?: string | undefined;
  sizeX120?: string | undefined;
  sizeX160?: string | undefined;
  sizeX176?: string | undefined;
  sizeX240?: string | undefined;
  sizeX360?: string | undefined;

  constructor(data?: IUserProfileImages) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.sizeX20 = _data["sizeX20"];
      this.sizeX40 = _data["sizeX40"];
      this.sizeX50 = _data["sizeX50"];
      this.sizeX58 = _data["sizeX58"];
      this.sizeX80 = _data["sizeX80"];
      this.sizeX120 = _data["sizeX120"];
      this.sizeX160 = _data["sizeX160"];
      this.sizeX176 = _data["sizeX176"];
      this.sizeX240 = _data["sizeX240"];
      this.sizeX360 = _data["sizeX360"];
    }
  }

  static fromJS(data: any): UserProfileImages {
    data = typeof data === 'object' ? data : {};
    let result = new UserProfileImages();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["sizeX20"] = this.sizeX20;
    data["sizeX40"] = this.sizeX40;
    data["sizeX50"] = this.sizeX50;
    data["sizeX58"] = this.sizeX58;
    data["sizeX80"] = this.sizeX80;
    data["sizeX120"] = this.sizeX120;
    data["sizeX160"] = this.sizeX160;
    data["sizeX176"] = this.sizeX176;
    data["sizeX240"] = this.sizeX240;
    data["sizeX360"] = this.sizeX360;
    return data;
  }
}

export interface IUserProfileImages {
  sizeX20?: string | undefined;
  sizeX40?: string | undefined;
  sizeX50?: string | undefined;
  sizeX58?: string | undefined;
  sizeX80?: string | undefined;
  sizeX120?: string | undefined;
  sizeX160?: string | undefined;
  sizeX176?: string | undefined;
  sizeX240?: string | undefined;
  sizeX360?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;

  constructor(data?: IProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property))
          this[property] = _data[property];
      }
      this.type = _data["type"];
      this.title = _data["title"];
      this.status = _data["status"];
      this.detail = _data["detail"];
      this.instance = _data["instance"];
    }
  }

  static fromJS(data: any): ProblemDetails {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property))
        data[property] = this[property];
    }
    data["type"] = this.type;
    data["title"] = this.title;
    data["status"] = this.status;
    data["detail"] = this.detail;
    data["instance"] = this.instance;
    return data;
  }
}

export interface IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;
}

export class JobBase implements IJobBase {
  id?: string;
  name?: string;
  description?: string | undefined;
  userId?: string;
  customerId?: string;
  hubId?: string;
  projectId?: string;
  models?: BitFile[];
  directories?: BitDirectory[];
  scheduleType?: JobScheduleType;
  schedule?: Schedule | undefined;
  lastRun?: JobRunBase | undefined;
  currentRun?: JobRunBase | undefined;
  nextRun?: JobRunBase | undefined;
  status?: JobStatusType;
  jobType?: JobType;
  storageType?: StorageType;
  bulkJobId?: string | undefined;
  scheduleEnvironment?: string | undefined;
  lastRunOrCreatedTime?: Date | undefined;

  constructor(data?: IJobBase) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.description = _data["description"];
      this.userId = _data["userId"];
      this.customerId = _data["customerId"];
      this.hubId = _data["hubId"];
      this.projectId = _data["projectId"];
      if (Array.isArray(_data["models"])) {
        this.models = [] as any;
        for (let item of _data["models"])
          this.models!.push(BitFile.fromJS(item));
      }
      if (Array.isArray(_data["directories"])) {
        this.directories = [] as any;
        for (let item of _data["directories"])
          this.directories!.push(BitDirectory.fromJS(item));
      }
      this.scheduleType = _data["scheduleType"];
      this.schedule = _data["schedule"] ? Schedule.fromJS(_data["schedule"]) : undefined as any;
      this.lastRun = _data["lastRun"] ? JobRunBase.fromJS(_data["lastRun"]) : undefined as any;
      this.currentRun = _data["currentRun"] ? JobRunBase.fromJS(_data["currentRun"]) : undefined as any;
      this.nextRun = _data["nextRun"] ? JobRunBase.fromJS(_data["nextRun"]) : undefined as any;
      this.status = _data["status"];
      this.jobType = _data["jobType"];
      this.storageType = _data["storageType"];
      this.bulkJobId = _data["bulkJobId"];
      this.scheduleEnvironment = _data["scheduleEnvironment"];
      this.lastRunOrCreatedTime = _data["lastRunOrCreatedTime"] ? new Date(_data["lastRunOrCreatedTime"].toString()) : undefined as any;
    }
  }

  static fromJS(data: any): JobBase {
    data = typeof data === 'object' ? data : {};
    let result = new JobBase();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["description"] = this.description;
    data["userId"] = this.userId;
    data["customerId"] = this.customerId;
    data["hubId"] = this.hubId;
    data["projectId"] = this.projectId;
    if (Array.isArray(this.models)) {
      data["models"] = [];
      for (let item of this.models)
        data["models"].push(item ? item.toJSON() : undefined as any);
    }
    if (Array.isArray(this.directories)) {
      data["directories"] = [];
      for (let item of this.directories)
        data["directories"].push(item ? item.toJSON() : undefined as any);
    }
    data["scheduleType"] = this.scheduleType;
    data["schedule"] = this.schedule ? this.schedule.toJSON() : undefined as any;
    data["lastRun"] = this.lastRun ? this.lastRun.toJSON() : undefined as any;
    data["currentRun"] = this.currentRun ? this.currentRun.toJSON() : undefined as any;
    data["nextRun"] = this.nextRun ? this.nextRun.toJSON() : undefined as any;
    data["status"] = this.status;
    data["jobType"] = this.jobType;
    data["storageType"] = this.storageType;
    data["bulkJobId"] = this.bulkJobId;
    data["scheduleEnvironment"] = this.scheduleEnvironment;
    data["lastRunOrCreatedTime"] = this.lastRunOrCreatedTime ? this.lastRunOrCreatedTime.toISOString() : undefined as any;
    return data;
  }
}

export interface IJobBase {
  id?: string;
  name?: string;
  description?: string | undefined;
  userId?: string;
  customerId?: string;
  hubId?: string;
  projectId?: string;
  models?: BitFile[];
  directories?: BitDirectory[];
  scheduleType?: JobScheduleType;
  schedule?: Schedule | undefined;
  lastRun?: JobRunBase | undefined;
  currentRun?: JobRunBase | undefined;
  nextRun?: JobRunBase | undefined;
  status?: JobStatusType;
  jobType?: JobType;
  storageType?: StorageType;
  bulkJobId?: string | undefined;
  scheduleEnvironment?: string | undefined;
  lastRunOrCreatedTime?: Date | undefined;
}

export class Job extends JobBase implements IJob {
  options?: DeckardJobOptions;
  nonDynamicDirectories?: BitDirectory[];

  constructor(data?: IJob) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.options = _data["options"] ? DeckardJobOptions.fromJS(_data["options"]) : undefined as any;
      if (Array.isArray(_data["nonDynamicDirectories"])) {
        this.nonDynamicDirectories = [] as any;
        for (let item of _data["nonDynamicDirectories"])
          this.nonDynamicDirectories!.push(BitDirectory.fromJS(item));
      }
    }
  }

  static override fromJS(data: any): Job {
    data = typeof data === 'object' ? data : {};
    let result = new Job();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["options"] = this.options ? this.options.toJSON() : undefined as any;
    if (Array.isArray(this.nonDynamicDirectories)) {
      data["nonDynamicDirectories"] = [];
      for (let item of this.nonDynamicDirectories)
        data["nonDynamicDirectories"].push(item ? item.toJSON() : undefined as any);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IJob extends IJobBase {
  options?: DeckardJobOptions;
  nonDynamicDirectories?: BitDirectory[];
}

export class DeckardJobOptions implements IDeckardJobOptions {
  locationType?: ExtractLocationType;
  destinationNamingType?: FileDestinationNamingType;
  directorySelectionOptions?: { [key: string]: DirectorySelectionOptions; } | undefined;
  singleFiles?: { [key: string]: string[]; } | undefined;
  extractDirectory?: DirectoryDto | undefined;
  emailPreferences?: EmailPreferences | undefined;
  doNotMaintainFolderStructure?: boolean;
  archive?: boolean;
  compositeExtractType?: CompositeExtractType;
  compositeRenamingType?: CompositeRenamingType;

  constructor(data?: IDeckardJobOptions) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.locationType = _data["locationType"];
      this.destinationNamingType = _data["destinationNamingType"];
      if (_data["directorySelectionOptions"]) {
        this.directorySelectionOptions = {} as any;
        for (let key in _data["directorySelectionOptions"]) {
          if (_data["directorySelectionOptions"].hasOwnProperty(key))
            (this.directorySelectionOptions as any)![key] = _data["directorySelectionOptions"][key] ? DirectorySelectionOptions.fromJS(_data["directorySelectionOptions"][key]) : new DirectorySelectionOptions();
        }
      }
      if (_data["singleFiles"]) {
        this.singleFiles = {} as any;
        for (let key in _data["singleFiles"]) {
          if (_data["singleFiles"].hasOwnProperty(key))
            (this.singleFiles as any)![key] = _data["singleFiles"][key] !== undefined ? _data["singleFiles"][key] : [];
        }
      }
      this.extractDirectory = _data["extractDirectory"] ? DirectoryDto.fromJS(_data["extractDirectory"]) : undefined as any;
      this.emailPreferences = _data["emailPreferences"] ? EmailPreferences.fromJS(_data["emailPreferences"]) : undefined as any;
      this.doNotMaintainFolderStructure = _data["doNotMaintainFolderStructure"];
      this.archive = _data["archive"];
      this.compositeExtractType = _data["compositeExtractType"];
      this.compositeRenamingType = _data["compositeRenamingType"];
    }
  }

  static fromJS(data: any): DeckardJobOptions {
    data = typeof data === 'object' ? data : {};
    let result = new DeckardJobOptions();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["locationType"] = this.locationType;
    data["destinationNamingType"] = this.destinationNamingType;
    if (this.directorySelectionOptions) {
      data["directorySelectionOptions"] = {};
      for (let key in this.directorySelectionOptions) {
        if (this.directorySelectionOptions.hasOwnProperty(key))
          (data["directorySelectionOptions"] as any)[key] = this.directorySelectionOptions[key] ? this.directorySelectionOptions[key].toJSON() : undefined as any;
      }
    }
    if (this.singleFiles) {
      data["singleFiles"] = {};
      for (let key in this.singleFiles) {
        if (this.singleFiles.hasOwnProperty(key))
          (data["singleFiles"] as any)[key] = (this.singleFiles as any)[key];
      }
    }
    data["extractDirectory"] = this.extractDirectory ? this.extractDirectory.toJSON() : undefined as any;
    data["emailPreferences"] = this.emailPreferences ? this.emailPreferences.toJSON() : undefined as any;
    data["doNotMaintainFolderStructure"] = this.doNotMaintainFolderStructure;
    data["archive"] = this.archive;
    data["compositeExtractType"] = this.compositeExtractType;
    data["compositeRenamingType"] = this.compositeRenamingType;
    return data;
  }
}

export interface IDeckardJobOptions {
  locationType?: ExtractLocationType;
  destinationNamingType?: FileDestinationNamingType;
  directorySelectionOptions?: { [key: string]: DirectorySelectionOptions; } | undefined;
  singleFiles?: { [key: string]: string[]; } | undefined;
  extractDirectory?: DirectoryDto | undefined;
  emailPreferences?: EmailPreferences | undefined;
  doNotMaintainFolderStructure?: boolean;
  archive?: boolean;
  compositeExtractType?: CompositeExtractType;
  compositeRenamingType?: CompositeRenamingType;
}

export enum ExtractLocationType {
  None = "None",
  ModelDirectory = "ModelDirectory",
  ModelSubdirectory = "ModelSubdirectory",
  OtherDirectory = "OtherDirectory",
  DirectDownload = "DirectDownload",
}

export enum FileDestinationNamingType {
  None = "None",
  Overwrite = "Overwrite",
  AppendTimestamp = "AppendTimestamp",
}

export class DirectorySelectionOptions implements IDirectorySelectionOptions {
  /** Gets or sets a value indicating whether subfolders and their contents should be included.
   */
  recursive?: boolean;
  /** Gets or sets a value indicating whether the selected folder should be created in the destination, or whether only
   its contents should be copied.
   */
  copyCurrentFolder?: boolean;
  /** Gets or sets the file type filters to apply to the directory. */
  fileTypeFilters?: string[];

  constructor(data?: IDirectorySelectionOptions) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.recursive = _data["recursive"];
      this.copyCurrentFolder = _data["copyCurrentFolder"];
      if (Array.isArray(_data["fileTypeFilters"])) {
        this.fileTypeFilters = [] as any;
        for (let item of _data["fileTypeFilters"])
          this.fileTypeFilters!.push(item);
      }
    }
  }

  static fromJS(data: any): DirectorySelectionOptions {
    data = typeof data === 'object' ? data : {};
    let result = new DirectorySelectionOptions();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["recursive"] = this.recursive;
    data["copyCurrentFolder"] = this.copyCurrentFolder;
    if (Array.isArray(this.fileTypeFilters)) {
      data["fileTypeFilters"] = [];
      for (let item of this.fileTypeFilters)
        data["fileTypeFilters"].push(item);
    }
    return data;
  }
}

export interface IDirectorySelectionOptions {
  /** Gets or sets a value indicating whether subfolders and their contents should be included.
   */
  recursive?: boolean;
  /** Gets or sets a value indicating whether the selected folder should be created in the destination, or whether only
   its contents should be copied.
   */
  copyCurrentFolder?: boolean;
  /** Gets or sets the file type filters to apply to the directory. */
  fileTypeFilters?: string[];
}

export abstract class FileOrDirectoryDto implements IFileOrDirectoryDto {
  id?: string;
  projectId?: string;
  hubId?: string;
  storageType?: StorageType;

  constructor(data?: IFileOrDirectoryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.projectId = _data["projectId"];
      this.hubId = _data["hubId"];
      this.storageType = _data["storageType"];
    }
  }

  static fromJS(data: any): FileOrDirectoryDto {
    data = typeof data === 'object' ? data : {};
    throw new Error("The abstract class 'FileOrDirectoryDto' cannot be instantiated.");
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["projectId"] = this.projectId;
    data["hubId"] = this.hubId;
    data["storageType"] = this.storageType;
    return data;
  }
}

export interface IFileOrDirectoryDto {
  id?: string;
  projectId?: string;
  hubId?: string;
  storageType?: StorageType;
}

export class DirectoryDto extends FileOrDirectoryDto implements IDirectoryDto {
  recursive?: boolean;

  constructor(data?: IDirectoryDto) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.recursive = _data["recursive"];
    }
  }

  static override fromJS(data: any): DirectoryDto {
    data = typeof data === 'object' ? data : {};
    let result = new DirectoryDto();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["recursive"] = this.recursive;
    super.toJSON(data);
    return data;
  }
}

export interface IDirectoryDto extends IFileOrDirectoryDto {
  recursive?: boolean;
}

export enum StorageType {
  Forge = "Forge",
  ProjectWise = "ProjectWise",
}

export class EmailPreferences implements IEmailPreferences {
  emailOnCompletion?: boolean;
  attachExportFiles?: boolean;

  constructor(data?: IEmailPreferences) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.emailOnCompletion = _data["emailOnCompletion"];
      this.attachExportFiles = _data["attachExportFiles"];
    }
  }

  static fromJS(data: any): EmailPreferences {
    data = typeof data === 'object' ? data : {};
    let result = new EmailPreferences();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["emailOnCompletion"] = this.emailOnCompletion;
    data["attachExportFiles"] = this.attachExportFiles;
    return data;
  }
}

export interface IEmailPreferences {
  emailOnCompletion?: boolean;
  attachExportFiles?: boolean;
}

export enum CompositeExtractType {
  ExtractAll = "ExtractAll",
  CopyComposite = "CopyComposite",
  ReSaveCloudModel = "ReSaveCloudModel",
}

export enum CompositeRenamingType {
  None = "None",
  RenameExisting = "RenameExisting",
  RenameCopied = "RenameCopied",
}

export abstract class FileOrDirectory implements IFileOrDirectory {
  id?: string;
  isDirectory?: boolean;
  name?: string;
  displayName?: string | undefined;
  parentId?: string | undefined;
  projectId?: string;
  lastUpdated?: Date;
  lastUpdatedBy?: string | undefined;
  isHidden?: boolean;

  protected _discriminator: string;

  constructor(data?: IFileOrDirectory) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
    this._discriminator = "FileOrDirectory";
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.isDirectory = _data["isDirectory"];
      this.name = _data["name"];
      this.displayName = _data["displayName"];
      this.parentId = _data["parentId"];
      this.projectId = _data["projectId"];
      this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : undefined as any;
      this.lastUpdatedBy = _data["lastUpdatedBy"];
      this.isHidden = _data["isHidden"];
    }
  }

  static fromJS(data: any): FileOrDirectory {
    data = typeof data === 'object' ? data : {};
    if (data["_discriminator"] === "BitFile") {
      throw new Error("The abstract class 'BitFile' cannot be instantiated.");
    }
    if (data["_discriminator"] === "BitFileBase") {
      throw new Error("The abstract class 'BitFileBase' cannot be instantiated.");
    }
    if (data["_discriminator"] === "File360") {
      let result = new File360();
      result.init(data);
      return result;
    }
    if (data["_discriminator"] === "BitDirectoryBase") {
      throw new Error("The abstract class 'BitDirectoryBase' cannot be instantiated.");
    }
    if (data["_discriminator"] === "ProjectWiseFile") {
      let result = new ProjectWiseFile();
      result.init(data);
      return result;
    }
    if (data["_discriminator"] === "JobFile") {
      let result = new JobFile();
      result.init(data);
      return result;
    }
    if (data["_discriminator"] === "BitDirectory") {
      throw new Error("The abstract class 'BitDirectory' cannot be instantiated.");
    }
    if (data["_discriminator"] === "JobDirectory") {
      let result = new JobDirectory();
      result.init(data);
      return result;
    }
    if (data["_discriminator"] === "Directory360") {
      let result = new Directory360();
      result.init(data);
      return result;
    }
    if (data["_discriminator"] === "ProjectWiseDirectory") {
      let result = new ProjectWiseDirectory();
      result.init(data);
      return result;
    }
    throw new Error("The abstract class 'FileOrDirectory' cannot be instantiated.");
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["_discriminator"] = this._discriminator;
    data["id"] = this.id;
    data["isDirectory"] = this.isDirectory;
    data["name"] = this.name;
    data["displayName"] = this.displayName;
    data["parentId"] = this.parentId;
    data["projectId"] = this.projectId;
    data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : undefined as any;
    data["lastUpdatedBy"] = this.lastUpdatedBy;
    data["isHidden"] = this.isHidden;
    return data;
  }
}

export interface IFileOrDirectory {
  id?: string;
  isDirectory?: boolean;
  name?: string;
  displayName?: string | undefined;
  parentId?: string | undefined;
  projectId?: string;
  lastUpdated?: Date;
  lastUpdatedBy?: string | undefined;
  isHidden?: boolean;
}

export abstract class BitDirectoryBase extends FileOrDirectory implements IBitDirectoryBase {
  isDirectory?: boolean;
  name?: string;

  constructor(data?: IBitDirectoryBase) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    this._discriminator = "BitDirectoryBase";
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.isDirectory = _data["isDirectory"];
      this.name = _data["name"];
    }
  }

  static override fromJS(data: any): BitDirectoryBase {
    data = typeof data === 'object' ? data : {};
    if (data["_discriminator"] === "BitDirectory") {
      throw new Error("The abstract class 'BitDirectory' cannot be instantiated.");
    }
    if (data["_discriminator"] === "JobDirectory") {
      let result = new JobDirectory();
      result.init(data);
      return result;
    }
    if (data["_discriminator"] === "Directory360") {
      let result = new Directory360();
      result.init(data);
      return result;
    }
    if (data["_discriminator"] === "ProjectWiseDirectory") {
      let result = new ProjectWiseDirectory();
      result.init(data);
      return result;
    }
    throw new Error("The abstract class 'BitDirectoryBase' cannot be instantiated.");
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["isDirectory"] = this.isDirectory;
    data["name"] = this.name;
    super.toJSON(data);
    return data;
  }
}

export interface IBitDirectoryBase extends IFileOrDirectory {
  isDirectory?: boolean;
  name?: string;
}

export abstract class BitDirectory extends BitDirectoryBase implements IBitDirectory {
  recursive?: boolean;
  parentName?: string | undefined;

  protected _discriminator: string;

  constructor(data?: IBitDirectory) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    this._discriminator = "BitDirectory";
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.recursive = _data["recursive"];
      this.parentName = _data["parentName"];
    }
  }

  static override fromJS(data: any): BitDirectory {
    data = typeof data === 'object' ? data : {};
    if (data["_discriminator"] === "JobDirectory") {
      let result = new JobDirectory();
      result.init(data);
      return result;
    }
    if (data["_discriminator"] === "ProjectWiseDirectory") {
      let result = new ProjectWiseDirectory();
      result.init(data);
      return result;
    }
    throw new Error("The abstract class 'BitDirectory' cannot be instantiated.");
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["_discriminator"] = this._discriminator;
    data["recursive"] = this.recursive;
    data["parentName"] = this.parentName;
    super.toJSON(data);
    return data;
  }
}

export interface IBitDirectory extends IBitDirectoryBase {
  recursive?: boolean;
  parentName?: string | undefined;
}

export abstract class BitFileBase extends FileOrDirectory implements IBitFileBase {
  directoryId?: string;
  fileType?: FileType;
  thumbnail?: string | undefined;
  isDirectory?: boolean;
  name?: string;
  size?: number;
  isLocked?: boolean;
  pathInProject?: string | undefined;
  /** Gets the file's object (storage) ID. This should be set for all valid files, but is missing in a variety of
   situations, so verification is needed to ensure it is present.
   */
  objectId?: string | undefined;
  isComposite?: boolean;
  versionNumber?: number;
  revitVersion?: string | undefined;
  mimeType?: string | undefined;
  fileNameWithExtension?: string;
  parentFolderDepth?: number;

  constructor(data?: IBitFileBase) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    this._discriminator = "BitFileBase";
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.directoryId = _data["directoryId"];
      this.fileType = _data["fileType"] ? FileType.fromJS(_data["fileType"]) : undefined as any;
      this.thumbnail = _data["thumbnail"];
      this.isDirectory = _data["isDirectory"];
      this.name = _data["name"];
      this.size = _data["size"];
      this.isLocked = _data["isLocked"];
      this.pathInProject = _data["pathInProject"];
      this.objectId = _data["objectId"];
      this.isComposite = _data["isComposite"];
      this.versionNumber = _data["versionNumber"];
      this.revitVersion = _data["revitVersion"];
      this.mimeType = _data["mimeType"];
      this.fileNameWithExtension = _data["fileNameWithExtension"];
      this.parentFolderDepth = _data["parentFolderDepth"];
    }
  }

  static override fromJS(data: any): BitFileBase {
    data = typeof data === 'object' ? data : {};
    if (data["_discriminator"] === "BitFile") {
      throw new Error("The abstract class 'BitFile' cannot be instantiated.");
    }
    if (data["_discriminator"] === "File360") {
      let result = new File360();
      result.init(data);
      return result;
    }
    if (data["_discriminator"] === "ProjectWiseFile") {
      let result = new ProjectWiseFile();
      result.init(data);
      return result;
    }
    if (data["_discriminator"] === "JobFile") {
      let result = new JobFile();
      result.init(data);
      return result;
    }
    throw new Error("The abstract class 'BitFileBase' cannot be instantiated.");
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["directoryId"] = this.directoryId;
    data["fileType"] = this.fileType ? this.fileType.toJSON() : undefined as any;
    data["thumbnail"] = this.thumbnail;
    data["isDirectory"] = this.isDirectory;
    data["name"] = this.name;
    data["size"] = this.size;
    data["isLocked"] = this.isLocked;
    data["pathInProject"] = this.pathInProject;
    data["objectId"] = this.objectId;
    data["isComposite"] = this.isComposite;
    data["versionNumber"] = this.versionNumber;
    data["revitVersion"] = this.revitVersion;
    data["mimeType"] = this.mimeType;
    data["fileNameWithExtension"] = this.fileNameWithExtension;
    data["parentFolderDepth"] = this.parentFolderDepth;
    super.toJSON(data);
    return data;
  }
}

export interface IBitFileBase extends IFileOrDirectory {
  directoryId?: string;
  fileType?: FileType;
  thumbnail?: string | undefined;
  isDirectory?: boolean;
  name?: string;
  size?: number;
  isLocked?: boolean;
  pathInProject?: string | undefined;
  /** Gets the file's object (storage) ID. This should be set for all valid files, but is missing in a variety of
   situations, so verification is needed to ensure it is present.
   */
  objectId?: string | undefined;
  isComposite?: boolean;
  versionNumber?: number;
  revitVersion?: string | undefined;
  mimeType?: string | undefined;
  fileNameWithExtension?: string;
  parentFolderDepth?: number;
}

export abstract class BitFile extends BitFileBase implements IBitFile {
  parentName?: string | undefined;

  protected _discriminator: string;

  constructor(data?: IBitFile) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    this._discriminator = "BitFile";
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.parentName = _data["parentName"];
    }
  }

  static override fromJS(data: any): BitFile {
    data = typeof data === 'object' ? data : {};
    if (data["_discriminator"] === "ProjectWiseFile") {
      let result = new ProjectWiseFile();
      result.init(data);
      return result;
    }
    if (data["_discriminator"] === "JobFile") {
      let result = new JobFile();
      result.init(data);
      return result;
    }
    throw new Error("The abstract class 'BitFile' cannot be instantiated.");
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["_discriminator"] = this._discriminator;
    data["parentName"] = this.parentName;
    super.toJSON(data);
    return data;
  }
}

export interface IBitFile extends IBitFileBase {
  parentName?: string | undefined;
}

export class JobFile extends BitFile implements IJobFile {
  hubId?: string;
  hubName?: string;
  region?: string;
  hubType?: HubType;
  projectName?: string;
  projectType?: ProjectType;
  derivativesId?: string | undefined;
  isProcessed?: boolean;
  compositeParentFile?: string | undefined;
  webViewUrl?: string | undefined;
  scopes?: string[];
  cloudFileType?: CloudFileType;

  constructor(data?: IJobFile) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    this._discriminator = "JobFile";
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.hubId = _data["hubId"];
      this.hubName = _data["hubName"];
      this.region = _data["region"];
      this.hubType = _data["hubType"];
      this.projectName = _data["projectName"];
      this.projectType = _data["projectType"];
      this.derivativesId = _data["derivativesId"];
      this.isProcessed = _data["isProcessed"];
      this.compositeParentFile = _data["compositeParentFile"];
      this.webViewUrl = _data["webViewUrl"];
      if (Array.isArray(_data["scopes"])) {
        this.scopes = [] as any;
        for (let item of _data["scopes"])
          this.scopes!.push(item);
      }
      this.cloudFileType = _data["cloudFileType"];
    }
  }

  static override fromJS(data: any): JobFile {
    data = typeof data === 'object' ? data : {};
    let result = new JobFile();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["hubId"] = this.hubId;
    data["hubName"] = this.hubName;
    data["region"] = this.region;
    data["hubType"] = this.hubType;
    data["projectName"] = this.projectName;
    data["projectType"] = this.projectType;
    data["derivativesId"] = this.derivativesId;
    data["isProcessed"] = this.isProcessed;
    data["compositeParentFile"] = this.compositeParentFile;
    data["webViewUrl"] = this.webViewUrl;
    if (Array.isArray(this.scopes)) {
      data["scopes"] = [];
      for (let item of this.scopes)
        data["scopes"].push(item);
    }
    data["cloudFileType"] = this.cloudFileType;
    super.toJSON(data);
    return data;
  }
}

export interface IJobFile extends IBitFile {
  hubId?: string;
  hubName?: string;
  region?: string;
  hubType?: HubType;
  projectName?: string;
  projectType?: ProjectType;
  derivativesId?: string | undefined;
  isProcessed?: boolean;
  compositeParentFile?: string | undefined;
  webViewUrl?: string | undefined;
  scopes?: string[];
  cloudFileType?: CloudFileType;
}

export enum HubType {
  Unknown = "Unknown",
  A360 = "A360",
  B360Team = "B360Team",
  B360 = "B360",
  ProjectWise = "ProjectWise",
  Deleted = "Deleted",
}

export enum ProjectType {
  Unknown = "Unknown",
  A360 = "A360",
  B360Team = "B360Team",
  B360Docs = "B360Docs",
  ACC = "ACC",
  ProjectWise = "ProjectWise",
  Deleted = "Deleted",
}

export enum CloudFileType {
  Standard = "Standard",
  Cloud = "Cloud",
  CloudWorkshared = "CloudWorkshared",
}

export class FileType implements IFileType {
  displayText?: string;
  /** Gets the file type description, for supported types. Otherwise, returns null.
   */
  fileDescription?: string | undefined;
  /** Gets the file extension, without the period.
   */
  fileExtension?: string;

  constructor(data?: IFileType) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.displayText = _data["displayText"];
      this.fileDescription = _data["fileDescription"];
      this.fileExtension = _data["fileExtension"];
    }
  }

  static fromJS(data: any): FileType {
    data = typeof data === 'object' ? data : {};
    let result = new FileType();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["displayText"] = this.displayText;
    data["fileDescription"] = this.fileDescription;
    data["fileExtension"] = this.fileExtension;
    return data;
  }
}

export interface IFileType {
  displayText?: string;
  /** Gets the file type description, for supported types. Otherwise, returns null.
   */
  fileDescription?: string | undefined;
  /** Gets the file extension, without the period.
   */
  fileExtension?: string;
}

export class ProjectWiseFile extends BitFile implements IProjectWiseFile {
  serverAddress?: string;
  projectName?: string;
  isLatest?: boolean;
  version?: string | undefined;
  isCheckedOut?: boolean;
  isFinal?: boolean;
  isReadOnly?: boolean;
  isWriteable?: boolean;
  eTag?: string | undefined;
  projectWiseFileClass?: ProjectWiseFileClass;
  fileOrDirectoryType?: FileOrDirectoryType;
  storageType?: StorageType;
  createdDate?: Date;

  constructor(data?: IProjectWiseFile) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    this._discriminator = "ProjectWiseFile";
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.serverAddress = _data["serverAddress"];
      this.projectName = _data["projectName"];
      this.isLatest = _data["isLatest"];
      this.version = _data["version"];
      this.isCheckedOut = _data["isCheckedOut"];
      this.isFinal = _data["isFinal"];
      this.isReadOnly = _data["isReadOnly"];
      this.isWriteable = _data["isWriteable"];
      this.eTag = _data["eTag"];
      this.projectWiseFileClass = _data["projectWiseFileClass"];
      this.fileOrDirectoryType = _data["fileOrDirectoryType"];
      this.storageType = _data["storageType"];
      this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
    }
  }

  static override fromJS(data: any): ProjectWiseFile {
    data = typeof data === 'object' ? data : {};
    let result = new ProjectWiseFile();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["serverAddress"] = this.serverAddress;
    data["projectName"] = this.projectName;
    data["isLatest"] = this.isLatest;
    data["version"] = this.version;
    data["isCheckedOut"] = this.isCheckedOut;
    data["isFinal"] = this.isFinal;
    data["isReadOnly"] = this.isReadOnly;
    data["isWriteable"] = this.isWriteable;
    data["eTag"] = this.eTag;
    data["projectWiseFileClass"] = this.projectWiseFileClass;
    data["fileOrDirectoryType"] = this.fileOrDirectoryType;
    data["storageType"] = this.storageType;
    data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
    super.toJSON(data);
    return data;
  }
}

export interface IProjectWiseFile extends IBitFile {
  serverAddress?: string;
  projectName?: string;
  isLatest?: boolean;
  version?: string | undefined;
  isCheckedOut?: boolean;
  isFinal?: boolean;
  isReadOnly?: boolean;
  isWriteable?: boolean;
  eTag?: string | undefined;
  projectWiseFileClass?: ProjectWiseFileClass;
  fileOrDirectoryType?: FileOrDirectoryType;
  storageType?: StorageType;
  createdDate?: Date;
}

export enum ProjectWiseFileClass {
  Document = "Document",
  LogicalSet = "LogicalSet",
  FlatSet = "FlatSet",
}

export enum FileOrDirectoryType {
  ForgeFile = "ForgeFile",
  ForgeDirectory = "ForgeDirectory",
  ProjectWiseFile = "ProjectWiseFile",
  ProjectWiseDirectory = "ProjectWiseDirectory",
}

export class JobDirectory extends BitDirectory implements IJobDirectory {
  hubId?: string;
  hubName?: string;
  hubType?: HubType;
  region?: string;
  projectName?: string;
  projectType?: ProjectType;
  /** Gets the collection of types visible. Note that this is only set for BIM 360 projects. It will always return an
   empty collection for A360 projects.
   */
  visibleTypes?: string[];
  folderType?: string | undefined;
  objectCount?: number;
  scopes?: string[];

  constructor(data?: IJobDirectory) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    this._discriminator = "JobDirectory";
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.hubId = _data["hubId"];
      this.hubName = _data["hubName"];
      this.hubType = _data["hubType"];
      this.region = _data["region"];
      this.projectName = _data["projectName"];
      this.projectType = _data["projectType"];
      if (Array.isArray(_data["visibleTypes"])) {
        this.visibleTypes = [] as any;
        for (let item of _data["visibleTypes"])
          this.visibleTypes!.push(item);
      }
      this.folderType = _data["folderType"];
      this.objectCount = _data["objectCount"];
      if (Array.isArray(_data["scopes"])) {
        this.scopes = [] as any;
        for (let item of _data["scopes"])
          this.scopes!.push(item);
      }
    }
  }

  static override fromJS(data: any): JobDirectory {
    data = typeof data === 'object' ? data : {};
    let result = new JobDirectory();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["hubId"] = this.hubId;
    data["hubName"] = this.hubName;
    data["hubType"] = this.hubType;
    data["region"] = this.region;
    data["projectName"] = this.projectName;
    data["projectType"] = this.projectType;
    if (Array.isArray(this.visibleTypes)) {
      data["visibleTypes"] = [];
      for (let item of this.visibleTypes)
        data["visibleTypes"].push(item);
    }
    data["folderType"] = this.folderType;
    data["objectCount"] = this.objectCount;
    if (Array.isArray(this.scopes)) {
      data["scopes"] = [];
      for (let item of this.scopes)
        data["scopes"].push(item);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IJobDirectory extends IBitDirectory {
  hubId?: string;
  hubName?: string;
  hubType?: HubType;
  region?: string;
  projectName?: string;
  projectType?: ProjectType;
  /** Gets the collection of types visible. Note that this is only set for BIM 360 projects. It will always return an
   empty collection for A360 projects.
   */
  visibleTypes?: string[];
  folderType?: string | undefined;
  objectCount?: number;
  scopes?: string[];
}

export class File360 extends BitFileBase implements IFile360 {
  derivativesId?: string | undefined;
  isProcessed?: boolean;
  compositeParentFile?: string | undefined;
  webViewUrl?: string | undefined;
  cloudFileType?: CloudFileType;

  constructor(data?: IFile360) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    this._discriminator = "File360";
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.derivativesId = _data["derivativesId"];
      this.isProcessed = _data["isProcessed"];
      this.compositeParentFile = _data["compositeParentFile"];
      this.webViewUrl = _data["webViewUrl"];
      this.cloudFileType = _data["cloudFileType"];
    }
  }

  static override fromJS(data: any): File360 {
    data = typeof data === 'object' ? data : {};
    let result = new File360();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["derivativesId"] = this.derivativesId;
    data["isProcessed"] = this.isProcessed;
    data["compositeParentFile"] = this.compositeParentFile;
    data["webViewUrl"] = this.webViewUrl;
    data["cloudFileType"] = this.cloudFileType;
    super.toJSON(data);
    return data;
  }
}

export interface IFile360 extends IBitFileBase {
  derivativesId?: string | undefined;
  isProcessed?: boolean;
  compositeParentFile?: string | undefined;
  webViewUrl?: string | undefined;
  cloudFileType?: CloudFileType;
}

export class Directory360 extends BitDirectoryBase implements IDirectory360 {
  /** Gets the collection of types visible. Note that this is only set for BIM 360 projects. It will always return an
   empty collection for A360 projects.
   */
  visibleTypes?: string[];
  folderType?: string | undefined;
  objectCount?: number;

  constructor(data?: IDirectory360) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    this._discriminator = "Directory360";
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["visibleTypes"])) {
        this.visibleTypes = [] as any;
        for (let item of _data["visibleTypes"])
          this.visibleTypes!.push(item);
      }
      this.folderType = _data["folderType"];
      this.objectCount = _data["objectCount"];
    }
  }

  static override fromJS(data: any): Directory360 {
    data = typeof data === 'object' ? data : {};
    let result = new Directory360();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.visibleTypes)) {
      data["visibleTypes"] = [];
      for (let item of this.visibleTypes)
        data["visibleTypes"].push(item);
    }
    data["folderType"] = this.folderType;
    data["objectCount"] = this.objectCount;
    super.toJSON(data);
    return data;
  }
}

export interface IDirectory360 extends IBitDirectoryBase {
  /** Gets the collection of types visible. Note that this is only set for BIM 360 projects. It will always return an
   empty collection for A360 projects.
   */
  visibleTypes?: string[];
  folderType?: string | undefined;
  objectCount?: number;
}

export class ProjectWiseDirectory extends BitDirectory implements IProjectWiseDirectory {
  serverAddress?: string;
  projectName?: string;
  createdDate?: Date;

  constructor(data?: IProjectWiseDirectory) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    this._discriminator = "ProjectWiseDirectory";
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.serverAddress = _data["serverAddress"];
      this.projectName = _data["projectName"];
      this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
    }
  }

  static override fromJS(data: any): ProjectWiseDirectory {
    data = typeof data === 'object' ? data : {};
    let result = new ProjectWiseDirectory();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["serverAddress"] = this.serverAddress;
    data["projectName"] = this.projectName;
    data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
    super.toJSON(data);
    return data;
  }
}

export interface IProjectWiseDirectory extends IBitDirectory {
  serverAddress?: string;
  projectName?: string;
  createdDate?: Date;
}

export enum JobScheduleType {
  None = "None",
  OnceNow = "OnceNow",
  OnceLater = "OnceLater",
  Recurring = "Recurring",
  OnPublish = "OnPublish",
}

export class Schedule implements ISchedule {
  cronString?: string;
  startDate?: Date | undefined;
  endDate?: Date | undefined;
  /** Gets or sets the maximum number of runs for this schedule. If MaxRuns is 0 then there is no maximum. */
  maxRuns?: number;
  isPaused?: boolean;

  constructor(data?: ISchedule) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.cronString = _data["cronString"];
      this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
      this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
      this.maxRuns = _data["maxRuns"];
      this.isPaused = _data["isPaused"];
    }
  }

  static fromJS(data: any): Schedule {
    data = typeof data === 'object' ? data : {};
    let result = new Schedule();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["cronString"] = this.cronString;
    data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
    data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
    data["maxRuns"] = this.maxRuns;
    data["isPaused"] = this.isPaused;
    return data;
  }
}

export interface ISchedule {
  cronString?: string;
  startDate?: Date | undefined;
  endDate?: Date | undefined;
  /** Gets or sets the maximum number of runs for this schedule. If MaxRuns is 0 then there is no maximum. */
  maxRuns?: number;
  isPaused?: boolean;
}

export class JobRunBase implements IJobRunBase {
  id?: string;
  jobId?: string;
  customerId?: string;
  userId?: string;
  startTime?: Date;
  jobRunItems?: JobRunItemBase[];
  jobRunItemInfos?: JobRunItemInfo[];
  status?: JobRunStatusType;
  errorMessage?: string | undefined;

  constructor(data?: IJobRunBase) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.jobId = _data["jobId"];
      this.customerId = _data["customerId"];
      this.userId = _data["userId"];
      this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
      if (Array.isArray(_data["jobRunItems"])) {
        this.jobRunItems = [] as any;
        for (let item of _data["jobRunItems"])
          this.jobRunItems!.push(JobRunItemBase.fromJS(item));
      }
      if (Array.isArray(_data["jobRunItemInfos"])) {
        this.jobRunItemInfos = [] as any;
        for (let item of _data["jobRunItemInfos"])
          this.jobRunItemInfos!.push(JobRunItemInfo.fromJS(item));
      }
      this.status = _data["status"];
      this.errorMessage = _data["errorMessage"];
    }
  }

  static fromJS(data: any): JobRunBase {
    data = typeof data === 'object' ? data : {};
    let result = new JobRunBase();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["jobId"] = this.jobId;
    data["customerId"] = this.customerId;
    data["userId"] = this.userId;
    data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
    if (Array.isArray(this.jobRunItems)) {
      data["jobRunItems"] = [];
      for (let item of this.jobRunItems)
        data["jobRunItems"].push(item ? item.toJSON() : undefined as any);
    }
    if (Array.isArray(this.jobRunItemInfos)) {
      data["jobRunItemInfos"] = [];
      for (let item of this.jobRunItemInfos)
        data["jobRunItemInfos"].push(item ? item.toJSON() : undefined as any);
    }
    data["status"] = this.status;
    data["errorMessage"] = this.errorMessage;
    return data;
  }
}

export interface IJobRunBase {
  id?: string;
  jobId?: string;
  customerId?: string;
  userId?: string;
  startTime?: Date;
  jobRunItems?: JobRunItemBase[];
  jobRunItemInfos?: JobRunItemInfo[];
  status?: JobRunStatusType;
  errorMessage?: string | undefined;
}

export class JobRunItemInfoBase implements IJobRunItemInfoBase {
  id?: string;
  status?: JobRunItemStatusType;

  constructor(data?: IJobRunItemInfoBase) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.status = _data["status"];
    }
  }

  static fromJS(data: any): JobRunItemInfoBase {
    data = typeof data === 'object' ? data : {};
    let result = new JobRunItemInfoBase();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["status"] = this.status;
    return data;
  }
}

export interface IJobRunItemInfoBase {
  id?: string;
  status?: JobRunItemStatusType;
}

export class JobRunItemInfo extends JobRunItemInfoBase implements IJobRunItemInfo {
  fileName?: string;
  errorType?: JobRunItemErrorType | undefined;

  constructor(data?: IJobRunItemInfo) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.fileName = _data["fileName"];
      this.errorType = _data["errorType"] ? JobRunItemErrorType.fromJS(_data["errorType"]) : undefined as any;
    }
  }

  static override fromJS(data: any): JobRunItemInfo {
    data = typeof data === 'object' ? data : {};
    let result = new JobRunItemInfo();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["fileName"] = this.fileName;
    data["errorType"] = this.errorType ? this.errorType.toJSON() : undefined as any;
    super.toJSON(data);
    return data;
  }
}

export interface IJobRunItemInfo extends IJobRunItemInfoBase {
  fileName?: string;
  errorType?: JobRunItemErrorType | undefined;
}

export class JobRunItemBase extends JobRunItemInfo implements IJobRunItemBase {
  jobRunId?: string;
  jobId?: string;
  customerId?: string;
  userId?: string;
  file?: BitFile;
  runStartTime?: string;
  runStartTimeNum?: number;
  workItemId?: string | undefined;
  workItem?: WorkItemDto | undefined;
  progress?: string | undefined;
  stats?: JobStats;

  constructor(data?: IJobRunItemBase) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.jobRunId = _data["jobRunId"];
      this.jobId = _data["jobId"];
      this.customerId = _data["customerId"];
      this.userId = _data["userId"];
      this.file = _data["file"] ? BitFile.fromJS(_data["file"]) : undefined as any;
      this.runStartTime = _data["runStartTime"];
      this.runStartTimeNum = _data["runStartTimeNum"];
      this.workItemId = _data["workItemId"];
      this.workItem = _data["workItem"] ? WorkItemDto.fromJS(_data["workItem"]) : undefined as any;
      this.progress = _data["progress"];
      this.stats = _data["stats"] ? JobStats.fromJS(_data["stats"]) : undefined as any;
    }
  }

  static override fromJS(data: any): JobRunItemBase {
    data = typeof data === 'object' ? data : {};
    let result = new JobRunItemBase();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["jobRunId"] = this.jobRunId;
    data["jobId"] = this.jobId;
    data["customerId"] = this.customerId;
    data["userId"] = this.userId;
    data["file"] = this.file ? this.file.toJSON() : undefined as any;
    data["runStartTime"] = this.runStartTime;
    data["runStartTimeNum"] = this.runStartTimeNum;
    data["workItemId"] = this.workItemId;
    data["workItem"] = this.workItem ? this.workItem.toJSON() : undefined as any;
    data["progress"] = this.progress;
    data["stats"] = this.stats ? this.stats.toJSON() : undefined as any;
    super.toJSON(data);
    return data;
  }
}

export interface IJobRunItemBase extends IJobRunItemInfo {
  jobRunId?: string;
  jobId?: string;
  customerId?: string;
  userId?: string;
  file?: BitFile;
  runStartTime?: string;
  runStartTimeNum?: number;
  workItemId?: string | undefined;
  workItem?: WorkItemDto | undefined;
  progress?: string | undefined;
  stats?: JobStats;
}

export class WorkItemDto implements IWorkItemDto {
  id?: string | undefined;
  activityId?: string;
  arguments?: { [key: string]: ArgumentDto; };
  signatures?: WorkItemSignaturesDto | undefined;
  limitProcessingTimeSec?: number | undefined;

  constructor(data?: IWorkItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.activityId = _data["activityId"];
      if (_data["arguments"]) {
        this.arguments = {} as any;
        for (let key in _data["arguments"]) {
          if (_data["arguments"].hasOwnProperty(key))
            (this.arguments as any)![key] = _data["arguments"][key] ? ArgumentDto.fromJS(_data["arguments"][key]) : new ArgumentDto();
        }
      }
      this.signatures = _data["signatures"] ? WorkItemSignaturesDto.fromJS(_data["signatures"]) : undefined as any;
      this.limitProcessingTimeSec = _data["limitProcessingTimeSec"];
    }
  }

  static fromJS(data: any): WorkItemDto {
    data = typeof data === 'object' ? data : {};
    let result = new WorkItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["activityId"] = this.activityId;
    if (this.arguments) {
      data["arguments"] = {};
      for (let key in this.arguments) {
        if (this.arguments.hasOwnProperty(key))
          (data["arguments"] as any)[key] = this.arguments[key] ? this.arguments[key].toJSON() : undefined as any;
      }
    }
    data["signatures"] = this.signatures ? this.signatures.toJSON() : undefined as any;
    data["limitProcessingTimeSec"] = this.limitProcessingTimeSec;
    return data;
  }
}

export interface IWorkItemDto {
  id?: string | undefined;
  activityId?: string;
  arguments?: { [key: string]: ArgumentDto; };
  signatures?: WorkItemSignaturesDto | undefined;
  limitProcessingTimeSec?: number | undefined;
}

export class ArgumentDto implements IArgumentDto {

  constructor(data?: IArgumentDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
  }

  static fromJS(data: any): ArgumentDto {
    data = typeof data === 'object' ? data : {};
    let result = new ArgumentDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    return data;
  }
}

export interface IArgumentDto {
}

export class WorkItemSignaturesDto implements IWorkItemSignaturesDto {
  activityId?: string;
  baseUrls?: SignedUrlDto[];

  constructor(data?: IWorkItemSignaturesDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.activityId = _data["activityId"];
      if (Array.isArray(_data["baseUrls"])) {
        this.baseUrls = [] as any;
        for (let item of _data["baseUrls"])
          this.baseUrls!.push(SignedUrlDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): WorkItemSignaturesDto {
    data = typeof data === 'object' ? data : {};
    let result = new WorkItemSignaturesDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["activityId"] = this.activityId;
    if (Array.isArray(this.baseUrls)) {
      data["baseUrls"] = [];
      for (let item of this.baseUrls)
        data["baseUrls"].push(item ? item.toJSON() : undefined as any);
    }
    return data;
  }
}

export interface IWorkItemSignaturesDto {
  activityId?: string;
  baseUrls?: SignedUrlDto[];
}

export class SignedUrlDto implements ISignedUrlDto {
  url?: string;
  signature?: string;

  constructor(data?: ISignedUrlDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.url = _data["url"];
      this.signature = _data["signature"];
    }
  }

  static fromJS(data: any): SignedUrlDto {
    data = typeof data === 'object' ? data : {};
    let result = new SignedUrlDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["url"] = this.url;
    data["signature"] = this.signature;
    return data;
  }
}

export interface ISignedUrlDto {
  url?: string;
  signature?: string;
}

export class JobStats implements IJobStats {
  timeDownloadStarted?: Date | undefined;
  timeInstructionsEnded?: Date | undefined;
  timeInstructionsStarted?: Date | undefined;
  timeQueued?: Date | undefined;
  timeUploadEnded?: Date | undefined;
  timeFinished?: Date | undefined;
  bytesDownloaded?: number | undefined;
  bytesUploaded?: number | undefined;

  constructor(data?: IJobStats) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.timeDownloadStarted = _data["timeDownloadStarted"] ? new Date(_data["timeDownloadStarted"].toString()) : undefined as any;
      this.timeInstructionsEnded = _data["timeInstructionsEnded"] ? new Date(_data["timeInstructionsEnded"].toString()) : undefined as any;
      this.timeInstructionsStarted = _data["timeInstructionsStarted"] ? new Date(_data["timeInstructionsStarted"].toString()) : undefined as any;
      this.timeQueued = _data["timeQueued"] ? new Date(_data["timeQueued"].toString()) : undefined as any;
      this.timeUploadEnded = _data["timeUploadEnded"] ? new Date(_data["timeUploadEnded"].toString()) : undefined as any;
      this.timeFinished = _data["timeFinished"] ? new Date(_data["timeFinished"].toString()) : undefined as any;
      this.bytesDownloaded = _data["bytesDownloaded"];
      this.bytesUploaded = _data["bytesUploaded"];
    }
  }

  static fromJS(data: any): JobStats {
    data = typeof data === 'object' ? data : {};
    let result = new JobStats();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["timeDownloadStarted"] = this.timeDownloadStarted ? this.timeDownloadStarted.toISOString() : undefined as any;
    data["timeInstructionsEnded"] = this.timeInstructionsEnded ? this.timeInstructionsEnded.toISOString() : undefined as any;
    data["timeInstructionsStarted"] = this.timeInstructionsStarted ? this.timeInstructionsStarted.toISOString() : undefined as any;
    data["timeQueued"] = this.timeQueued ? this.timeQueued.toISOString() : undefined as any;
    data["timeUploadEnded"] = this.timeUploadEnded ? this.timeUploadEnded.toISOString() : undefined as any;
    data["timeFinished"] = this.timeFinished ? this.timeFinished.toISOString() : undefined as any;
    data["bytesDownloaded"] = this.bytesDownloaded;
    data["bytesUploaded"] = this.bytesUploaded;
    return data;
  }
}

export interface IJobStats {
  timeDownloadStarted?: Date | undefined;
  timeInstructionsEnded?: Date | undefined;
  timeInstructionsStarted?: Date | undefined;
  timeQueued?: Date | undefined;
  timeUploadEnded?: Date | undefined;
  timeFinished?: Date | undefined;
  bytesDownloaded?: number | undefined;
  bytesUploaded?: number | undefined;
}

export class JobRunItemErrorType implements IJobRunItemErrorType {
  errorCode?: number;
  message?: string;
  isRetryable?: boolean;

  constructor(data?: IJobRunItemErrorType) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.errorCode = _data["errorCode"];
      this.message = _data["message"];
      this.isRetryable = _data["isRetryable"];
    }
  }

  static fromJS(data: any): JobRunItemErrorType {
    data = typeof data === 'object' ? data : {};
    let result = new JobRunItemErrorType();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["errorCode"] = this.errorCode;
    data["message"] = this.message;
    data["isRetryable"] = this.isRetryable;
    return data;
  }
}

export interface IJobRunItemErrorType {
  errorCode?: number;
  message?: string;
  isRetryable?: boolean;
}

export enum JobRunItemStatusType {
  Pending = "Pending",
  InProgress = "InProgress",
  Cancelled = "Cancelled",
  FailedLimitDataSize = "FailedLimitDataSize",
  FailedLimitProcessingTime = "FailedLimitProcessingTime",
  FailedDownload = "FailedDownload",
  FailedInstructions = "FailedInstructions",
  FailedUpload = "FailedUpload",
  FailedUploadOptional = "FailedUploadOptional",
  Success = "Success",
  Error = "Error",
}

export enum JobRunStatusType {
  Cancelled = "Cancelled",
  Scheduled = "Scheduled",
  Queued = "Queued",
  InProgress = "InProgress",
  PostProcessing = "PostProcessing",
  Success = "Success",
  Error = "Error",
  PartiallyCompleted = "PartiallyCompleted",
}

export enum JobStatusType {
  None = "None",
  Scheduled = "Scheduled",
  Running = "Running",
  Paused = "Paused",
  Completed = "Completed",
  Error = "Error",
  PostProcessing = "PostProcessing",
  PartiallyCompleted = "PartiallyCompleted",
}

export enum JobType {
  Standard = "Standard",
  DesignAutomation = "DesignAutomation",
}

export class CreateJobRequestBase implements ICreateJobRequestBase {
  name?: string | undefined;
  description?: string | undefined;
  models?: FileDto[] | undefined;
  directories?: DirectoryDto[] | undefined;
  jobScheduleType?: JobScheduleType;
  schedule?: Schedule | undefined;
  runOnceDateTime?: Date | undefined;
  paused?: boolean;
  idPrefix?: string | undefined;

  constructor(data?: ICreateJobRequestBase) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.description = _data["description"];
      if (Array.isArray(_data["models"])) {
        this.models = [] as any;
        for (let item of _data["models"])
          this.models!.push(FileDto.fromJS(item));
      }
      if (Array.isArray(_data["directories"])) {
        this.directories = [] as any;
        for (let item of _data["directories"])
          this.directories!.push(DirectoryDto.fromJS(item));
      }
      this.jobScheduleType = _data["jobScheduleType"];
      this.schedule = _data["schedule"] ? Schedule.fromJS(_data["schedule"]) : undefined as any;
      this.runOnceDateTime = _data["runOnceDateTime"] ? new Date(_data["runOnceDateTime"].toString()) : undefined as any;
      this.paused = _data["paused"];
      this.idPrefix = _data["idPrefix"];
    }
  }

  static fromJS(data: any): CreateJobRequestBase {
    data = typeof data === 'object' ? data : {};
    let result = new CreateJobRequestBase();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["description"] = this.description;
    if (Array.isArray(this.models)) {
      data["models"] = [];
      for (let item of this.models)
        data["models"].push(item ? item.toJSON() : undefined as any);
    }
    if (Array.isArray(this.directories)) {
      data["directories"] = [];
      for (let item of this.directories)
        data["directories"].push(item ? item.toJSON() : undefined as any);
    }
    data["jobScheduleType"] = this.jobScheduleType;
    data["schedule"] = this.schedule ? this.schedule.toJSON() : undefined as any;
    data["runOnceDateTime"] = this.runOnceDateTime ? this.runOnceDateTime.toISOString() : undefined as any;
    data["paused"] = this.paused;
    data["idPrefix"] = this.idPrefix;
    return data;
  }
}

export interface ICreateJobRequestBase {
  name?: string | undefined;
  description?: string | undefined;
  models?: FileDto[] | undefined;
  directories?: DirectoryDto[] | undefined;
  jobScheduleType?: JobScheduleType;
  schedule?: Schedule | undefined;
  runOnceDateTime?: Date | undefined;
  paused?: boolean;
  idPrefix?: string | undefined;
}

export class CreateJobRequest extends CreateJobRequestBase implements ICreateJobRequest {
  options?: DeckardJobOptions | undefined;
  nonDynamicDirectories?: DirectoryDto[] | undefined;
  bulkTaskId?: string | undefined;

  constructor(data?: ICreateJobRequest) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.options = _data["options"] ? DeckardJobOptions.fromJS(_data["options"]) : undefined as any;
      if (Array.isArray(_data["nonDynamicDirectories"])) {
        this.nonDynamicDirectories = [] as any;
        for (let item of _data["nonDynamicDirectories"])
          this.nonDynamicDirectories!.push(DirectoryDto.fromJS(item));
      }
      this.bulkTaskId = _data["bulkTaskId"];
    }
  }

  static override fromJS(data: any): CreateJobRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateJobRequest();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["options"] = this.options ? this.options.toJSON() : undefined as any;
    if (Array.isArray(this.nonDynamicDirectories)) {
      data["nonDynamicDirectories"] = [];
      for (let item of this.nonDynamicDirectories)
        data["nonDynamicDirectories"].push(item ? item.toJSON() : undefined as any);
    }
    data["bulkTaskId"] = this.bulkTaskId;
    super.toJSON(data);
    return data;
  }
}

export interface ICreateJobRequest extends ICreateJobRequestBase {
  options?: DeckardJobOptions | undefined;
  nonDynamicDirectories?: DirectoryDto[] | undefined;
  bulkTaskId?: string | undefined;
}

export class FileDto extends FileOrDirectoryDto implements IFileDto {
  projectWiseFileClass?: ProjectWiseFileClass | undefined;

  constructor(data?: IFileDto) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.projectWiseFileClass = _data["projectWiseFileClass"];
    }
  }

  static override fromJS(data: any): FileDto {
    data = typeof data === 'object' ? data : {};
    let result = new FileDto();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["projectWiseFileClass"] = this.projectWiseFileClass;
    super.toJSON(data);
    return data;
  }
}

export interface IFileDto extends IFileOrDirectoryDto {
  projectWiseFileClass?: ProjectWiseFileClass | undefined;
}

export class EditJobRequestBase implements IEditJobRequestBase {
  name?: string | undefined;
  description?: string | undefined;
  clearDescription?: boolean;
  jobScheduleType?: JobScheduleType | undefined;
  editSchedule?: EditScheduleRequest | undefined;
  runOnceDateTime?: Date | undefined;
  pauseJob?: boolean | undefined;

  constructor(data?: IEditJobRequestBase) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.description = _data["description"];
      this.clearDescription = _data["clearDescription"];
      this.jobScheduleType = _data["jobScheduleType"];
      this.editSchedule = _data["editSchedule"] ? EditScheduleRequest.fromJS(_data["editSchedule"]) : undefined as any;
      this.runOnceDateTime = _data["runOnceDateTime"] ? new Date(_data["runOnceDateTime"].toString()) : undefined as any;
      this.pauseJob = _data["pauseJob"];
    }
  }

  static fromJS(data: any): EditJobRequestBase {
    data = typeof data === 'object' ? data : {};
    let result = new EditJobRequestBase();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    data["description"] = this.description;
    data["clearDescription"] = this.clearDescription;
    data["jobScheduleType"] = this.jobScheduleType;
    data["editSchedule"] = this.editSchedule ? this.editSchedule.toJSON() : undefined as any;
    data["runOnceDateTime"] = this.runOnceDateTime ? this.runOnceDateTime.toISOString() : undefined as any;
    data["pauseJob"] = this.pauseJob;
    return data;
  }
}

export interface IEditJobRequestBase {
  name?: string | undefined;
  description?: string | undefined;
  clearDescription?: boolean;
  jobScheduleType?: JobScheduleType | undefined;
  editSchedule?: EditScheduleRequest | undefined;
  runOnceDateTime?: Date | undefined;
  pauseJob?: boolean | undefined;
}

export class EditJobRequest extends EditJobRequestBase implements IEditJobRequest {
  addFiles?: FileDto[] | undefined;
  removeFiles?: FileDto[] | undefined;
  addDirectories?: DirectoryDto[] | undefined;
  removeDirectories?: DirectoryDto[] | undefined;
  addNonDynamicDirectories?: DirectoryDto[] | undefined;
  removeNonDynamicDirectories?: DirectoryDto[] | undefined;
  options?: DeckardJobOptions | undefined;

  constructor(data?: IEditJobRequest) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["addFiles"])) {
        this.addFiles = [] as any;
        for (let item of _data["addFiles"])
          this.addFiles!.push(FileDto.fromJS(item));
      }
      if (Array.isArray(_data["removeFiles"])) {
        this.removeFiles = [] as any;
        for (let item of _data["removeFiles"])
          this.removeFiles!.push(FileDto.fromJS(item));
      }
      if (Array.isArray(_data["addDirectories"])) {
        this.addDirectories = [] as any;
        for (let item of _data["addDirectories"])
          this.addDirectories!.push(DirectoryDto.fromJS(item));
      }
      if (Array.isArray(_data["removeDirectories"])) {
        this.removeDirectories = [] as any;
        for (let item of _data["removeDirectories"])
          this.removeDirectories!.push(DirectoryDto.fromJS(item));
      }
      if (Array.isArray(_data["addNonDynamicDirectories"])) {
        this.addNonDynamicDirectories = [] as any;
        for (let item of _data["addNonDynamicDirectories"])
          this.addNonDynamicDirectories!.push(DirectoryDto.fromJS(item));
      }
      if (Array.isArray(_data["removeNonDynamicDirectories"])) {
        this.removeNonDynamicDirectories = [] as any;
        for (let item of _data["removeNonDynamicDirectories"])
          this.removeNonDynamicDirectories!.push(DirectoryDto.fromJS(item));
      }
      this.options = _data["options"] ? DeckardJobOptions.fromJS(_data["options"]) : undefined as any;
    }
  }

  static override fromJS(data: any): EditJobRequest {
    data = typeof data === 'object' ? data : {};
    let result = new EditJobRequest();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.addFiles)) {
      data["addFiles"] = [];
      for (let item of this.addFiles)
        data["addFiles"].push(item ? item.toJSON() : undefined as any);
    }
    if (Array.isArray(this.removeFiles)) {
      data["removeFiles"] = [];
      for (let item of this.removeFiles)
        data["removeFiles"].push(item ? item.toJSON() : undefined as any);
    }
    if (Array.isArray(this.addDirectories)) {
      data["addDirectories"] = [];
      for (let item of this.addDirectories)
        data["addDirectories"].push(item ? item.toJSON() : undefined as any);
    }
    if (Array.isArray(this.removeDirectories)) {
      data["removeDirectories"] = [];
      for (let item of this.removeDirectories)
        data["removeDirectories"].push(item ? item.toJSON() : undefined as any);
    }
    if (Array.isArray(this.addNonDynamicDirectories)) {
      data["addNonDynamicDirectories"] = [];
      for (let item of this.addNonDynamicDirectories)
        data["addNonDynamicDirectories"].push(item ? item.toJSON() : undefined as any);
    }
    if (Array.isArray(this.removeNonDynamicDirectories)) {
      data["removeNonDynamicDirectories"] = [];
      for (let item of this.removeNonDynamicDirectories)
        data["removeNonDynamicDirectories"].push(item ? item.toJSON() : undefined as any);
    }
    data["options"] = this.options ? this.options.toJSON() : undefined as any;
    super.toJSON(data);
    return data;
  }
}

export interface IEditJobRequest extends IEditJobRequestBase {
  addFiles?: FileDto[] | undefined;
  removeFiles?: FileDto[] | undefined;
  addDirectories?: DirectoryDto[] | undefined;
  removeDirectories?: DirectoryDto[] | undefined;
  addNonDynamicDirectories?: DirectoryDto[] | undefined;
  removeNonDynamicDirectories?: DirectoryDto[] | undefined;
  options?: DeckardJobOptions | undefined;
}

export class EditScheduleRequest implements IEditScheduleRequest {
  cronString?: string | undefined;
  startDate?: Date | undefined;
  clearStartDate?: boolean;
  endDate?: Date | undefined;
  clearEndDate?: boolean;
  /** Gets or sets the maximum number of runs. If null, no changes will be made. Set to 0 to remove the limit. */
  maxRuns?: number | undefined;

  constructor(data?: IEditScheduleRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.cronString = _data["cronString"];
      this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
      this.clearStartDate = _data["clearStartDate"];
      this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
      this.clearEndDate = _data["clearEndDate"];
      this.maxRuns = _data["maxRuns"];
    }
  }

  static fromJS(data: any): EditScheduleRequest {
    data = typeof data === 'object' ? data : {};
    let result = new EditScheduleRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["cronString"] = this.cronString;
    data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
    data["clearStartDate"] = this.clearStartDate;
    data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
    data["clearEndDate"] = this.clearEndDate;
    data["maxRuns"] = this.maxRuns;
    return data;
  }
}

export interface IEditScheduleRequest {
  cronString?: string | undefined;
  startDate?: Date | undefined;
  clearStartDate?: boolean;
  endDate?: Date | undefined;
  clearEndDate?: boolean;
  /** Gets or sets the maximum number of runs. If null, no changes will be made. Set to 0 to remove the limit. */
  maxRuns?: number | undefined;
}

export class JobRun extends JobRunBase implements IJobRun {
  jobRunItems?: JobRunItem[];

  constructor(data?: IJobRun) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["jobRunItems"])) {
        this.jobRunItems = [] as any;
        for (let item of _data["jobRunItems"])
          this.jobRunItems!.push(JobRunItem.fromJS(item));
      }
    }
  }

  static override fromJS(data: any): JobRun {
    data = typeof data === 'object' ? data : {};
    let result = new JobRun();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.jobRunItems)) {
      data["jobRunItems"] = [];
      for (let item of this.jobRunItems)
        data["jobRunItems"].push(item ? item.toJSON() : undefined as any);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IJobRun extends IJobRunBase {
  jobRunItems?: JobRunItem[];
}

export class JobRunItem extends JobRunItemBase implements IJobRunItem {

  constructor(data?: IJobRunItem) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): JobRunItem {
    data = typeof data === 'object' ? data : {};
    let result = new JobRunItem();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IJobRunItem extends IJobRunItemBase {
}

export class DownloadDto implements IDownloadDto {
  isReady?: boolean;
  isError?: boolean;
  downloadUrl?: string | undefined;
  fileName?: string | undefined;
  errorMessage?: string | undefined;
  fullExceptionInfo?: string | undefined;
  isDone?: boolean;
  downloadUrls?: string[];
  fileNames?: string[];

  constructor(data?: IDownloadDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isReady = _data["isReady"];
      this.isError = _data["isError"];
      this.downloadUrl = _data["downloadUrl"];
      this.fileName = _data["fileName"];
      this.errorMessage = _data["errorMessage"];
      this.fullExceptionInfo = _data["fullExceptionInfo"];
      this.isDone = _data["isDone"];
      if (Array.isArray(_data["downloadUrls"])) {
        this.downloadUrls = [] as any;
        for (let item of _data["downloadUrls"])
          this.downloadUrls!.push(item);
      }
      if (Array.isArray(_data["fileNames"])) {
        this.fileNames = [] as any;
        for (let item of _data["fileNames"])
          this.fileNames!.push(item);
      }
    }
  }

  static fromJS(data: any): DownloadDto {
    data = typeof data === 'object' ? data : {};
    let result = new DownloadDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["isReady"] = this.isReady;
    data["isError"] = this.isError;
    data["downloadUrl"] = this.downloadUrl;
    data["fileName"] = this.fileName;
    data["errorMessage"] = this.errorMessage;
    data["fullExceptionInfo"] = this.fullExceptionInfo;
    data["isDone"] = this.isDone;
    if (Array.isArray(this.downloadUrls)) {
      data["downloadUrls"] = [];
      for (let item of this.downloadUrls)
        data["downloadUrls"].push(item);
    }
    if (Array.isArray(this.fileNames)) {
      data["fileNames"] = [];
      for (let item of this.fileNames)
        data["fileNames"].push(item);
    }
    return data;
  }
}

export interface IDownloadDto {
  isReady?: boolean;
  isError?: boolean;
  downloadUrl?: string | undefined;
  fileName?: string | undefined;
  errorMessage?: string | undefined;
  fullExceptionInfo?: string | undefined;
  isDone?: boolean;
  downloadUrls?: string[];
  fileNames?: string[];
}

export class UsageBase implements IUsageBase {
  paginationDataDictionary?: { [key: string]: PaginationData; };
  paginationData?: PaginationData | undefined;
  isDoneDictionary?: { [key: string]: boolean; };
  isDone?: boolean;

  constructor(data?: IUsageBase) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data["paginationDataDictionary"]) {
        this.paginationDataDictionary = {} as any;
        for (let key in _data["paginationDataDictionary"]) {
          if (_data["paginationDataDictionary"].hasOwnProperty(key))
            (this.paginationDataDictionary as any)![key] = _data["paginationDataDictionary"][key] ? PaginationData.fromJS(_data["paginationDataDictionary"][key]) : new PaginationData();
        }
      }
      this.paginationData = _data["paginationData"] ? PaginationData.fromJS(_data["paginationData"]) : undefined as any;
      if (_data["isDoneDictionary"]) {
        this.isDoneDictionary = {} as any;
        for (let key in _data["isDoneDictionary"]) {
          if (_data["isDoneDictionary"].hasOwnProperty(key))
            (this.isDoneDictionary as any)![key] = _data["isDoneDictionary"][key];
        }
      }
      this.isDone = _data["isDone"];
    }
  }

  static fromJS(data: any): UsageBase {
    data = typeof data === 'object' ? data : {};
    let result = new UsageBase();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.paginationDataDictionary) {
      data["paginationDataDictionary"] = {};
      for (let key in this.paginationDataDictionary) {
        if (this.paginationDataDictionary.hasOwnProperty(key))
          (data["paginationDataDictionary"] as any)[key] = this.paginationDataDictionary[key] ? this.paginationDataDictionary[key].toJSON() : undefined as any;
      }
    }
    data["paginationData"] = this.paginationData ? this.paginationData.toJSON() : undefined as any;
    if (this.isDoneDictionary) {
      data["isDoneDictionary"] = {};
      for (let key in this.isDoneDictionary) {
        if (this.isDoneDictionary.hasOwnProperty(key))
          (data["isDoneDictionary"] as any)[key] = (this.isDoneDictionary as any)[key];
      }
    }
    data["isDone"] = this.isDone;
    return data;
  }
}

export interface IUsageBase {
  paginationDataDictionary?: { [key: string]: PaginationData; };
  paginationData?: PaginationData | undefined;
  isDoneDictionary?: { [key: string]: boolean; };
  isDone?: boolean;
}

export class DetailedUsageBase extends UsageBase implements IDetailedUsageBase {
  entries?: JobDataEntry[];

  constructor(data?: IDetailedUsageBase) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["entries"])) {
        this.entries = [] as any;
        for (let item of _data["entries"])
          this.entries!.push(JobDataEntry.fromJS(item));
      }
    }
  }

  static override fromJS(data: any): DetailedUsageBase {
    data = typeof data === 'object' ? data : {};
    let result = new DetailedUsageBase();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.entries)) {
      data["entries"] = [];
      for (let item of this.entries)
        data["entries"].push(item ? item.toJSON() : undefined as any);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IDetailedUsageBase extends IUsageBase {
  entries?: JobDataEntry[];
}

export class DetailedUsage extends DetailedUsageBase implements IDetailedUsage {
  entries?: DeckardJobDataEntry[];

  constructor(data?: IDetailedUsage) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["entries"])) {
        this.entries = [] as any;
        for (let item of _data["entries"])
          this.entries!.push(DeckardJobDataEntry.fromJS(item));
      }
    }
  }

  static override fromJS(data: any): DetailedUsage {
    data = typeof data === 'object' ? data : {};
    let result = new DetailedUsage();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.entries)) {
      data["entries"] = [];
      for (let item of this.entries)
        data["entries"].push(item ? item.toJSON() : undefined as any);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IDetailedUsage extends IDetailedUsageBase {
  entries?: DeckardJobDataEntry[];
}

export class JobDataEntry implements IJobDataEntry {
  runData?: JobRunDataEntry;
  workItem?: WorkItemDto | undefined;
  id?: string;
  modelStatus?: string;
  sourceModelId?: string;
  sourceFileNameWithExtension?: string;
  sourceDirectoryId?: string;
  sourceDirectoryName?: string | undefined;
  sourceFileSize?: number;
  sourceFileModifiedTime?: Date | undefined;
  createdDate?: Date | undefined;
  updatedDate?: Date | undefined;
  modifiedDate?: Date | undefined;
  errorCode?: string | undefined;
  errorMessage?: string | undefined;
  developerErrorMessage?: string | undefined;
  fullErrorInfo?: string | undefined;
  workItemId?: string | undefined;
  progress?: string | undefined;
  logUri?: string | undefined;
  timeDownloadStarted?: Date | undefined;
  timeInstructionsEnded?: Date | undefined;
  timeInstructionsStarted?: Date | undefined;
  timeQueued?: Date | undefined;
  timeUploadEnded?: Date | undefined;
  timeFinished?: Date | undefined;
  bytesDownloaded?: number | undefined;
  bytesUploaded?: number | undefined;
  activityId?: string | undefined;
  creditTimeSeconds?: number | undefined;
  secondsPerMB?: number | undefined;
  modelRevitVersion?: string | undefined;
  numberOfRetries?: number;
  retryErrors?: string | undefined;

  constructor(data?: IJobDataEntry) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.runData = _data["runData"] ? JobRunDataEntry.fromJS(_data["runData"]) : undefined as any;
      this.workItem = _data["workItem"] ? WorkItemDto.fromJS(_data["workItem"]) : undefined as any;
      this.id = _data["id"];
      this.modelStatus = _data["modelStatus"];
      this.sourceModelId = _data["sourceModelId"];
      this.sourceFileNameWithExtension = _data["sourceFileNameWithExtension"];
      this.sourceDirectoryId = _data["sourceDirectoryId"];
      this.sourceDirectoryName = _data["sourceDirectoryName"];
      this.sourceFileSize = _data["sourceFileSize"];
      this.sourceFileModifiedTime = _data["sourceFileModifiedTime"] ? new Date(_data["sourceFileModifiedTime"].toString()) : undefined as any;
      this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
      this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : undefined as any;
      this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : undefined as any;
      this.errorCode = _data["errorCode"];
      this.errorMessage = _data["errorMessage"];
      this.developerErrorMessage = _data["developerErrorMessage"];
      this.fullErrorInfo = _data["fullErrorInfo"];
      this.workItemId = _data["workItemId"];
      this.progress = _data["progress"];
      this.logUri = _data["logUri"];
      this.timeDownloadStarted = _data["timeDownloadStarted"] ? new Date(_data["timeDownloadStarted"].toString()) : undefined as any;
      this.timeInstructionsEnded = _data["timeInstructionsEnded"] ? new Date(_data["timeInstructionsEnded"].toString()) : undefined as any;
      this.timeInstructionsStarted = _data["timeInstructionsStarted"] ? new Date(_data["timeInstructionsStarted"].toString()) : undefined as any;
      this.timeQueued = _data["timeQueued"] ? new Date(_data["timeQueued"].toString()) : undefined as any;
      this.timeUploadEnded = _data["timeUploadEnded"] ? new Date(_data["timeUploadEnded"].toString()) : undefined as any;
      this.timeFinished = _data["timeFinished"] ? new Date(_data["timeFinished"].toString()) : undefined as any;
      this.bytesDownloaded = _data["bytesDownloaded"];
      this.bytesUploaded = _data["bytesUploaded"];
      this.activityId = _data["activityId"];
      this.creditTimeSeconds = _data["creditTimeSeconds"];
      this.secondsPerMB = _data["secondsPerMB"];
      this.modelRevitVersion = _data["modelRevitVersion"];
      this.numberOfRetries = _data["numberOfRetries"];
      this.retryErrors = _data["retryErrors"];
    }
  }

  static fromJS(data: any): JobDataEntry {
    data = typeof data === 'object' ? data : {};
    let result = new JobDataEntry();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["runData"] = this.runData ? this.runData.toJSON() : undefined as any;
    data["workItem"] = this.workItem ? this.workItem.toJSON() : undefined as any;
    data["id"] = this.id;
    data["modelStatus"] = this.modelStatus;
    data["sourceModelId"] = this.sourceModelId;
    data["sourceFileNameWithExtension"] = this.sourceFileNameWithExtension;
    data["sourceDirectoryId"] = this.sourceDirectoryId;
    data["sourceDirectoryName"] = this.sourceDirectoryName;
    data["sourceFileSize"] = this.sourceFileSize;
    data["sourceFileModifiedTime"] = this.sourceFileModifiedTime ? this.sourceFileModifiedTime.toISOString() : undefined as any;
    data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
    data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : undefined as any;
    data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : undefined as any;
    data["errorCode"] = this.errorCode;
    data["errorMessage"] = this.errorMessage;
    data["developerErrorMessage"] = this.developerErrorMessage;
    data["fullErrorInfo"] = this.fullErrorInfo;
    data["workItemId"] = this.workItemId;
    data["progress"] = this.progress;
    data["logUri"] = this.logUri;
    data["timeDownloadStarted"] = this.timeDownloadStarted ? this.timeDownloadStarted.toISOString() : undefined as any;
    data["timeInstructionsEnded"] = this.timeInstructionsEnded ? this.timeInstructionsEnded.toISOString() : undefined as any;
    data["timeInstructionsStarted"] = this.timeInstructionsStarted ? this.timeInstructionsStarted.toISOString() : undefined as any;
    data["timeQueued"] = this.timeQueued ? this.timeQueued.toISOString() : undefined as any;
    data["timeUploadEnded"] = this.timeUploadEnded ? this.timeUploadEnded.toISOString() : undefined as any;
    data["timeFinished"] = this.timeFinished ? this.timeFinished.toISOString() : undefined as any;
    data["bytesDownloaded"] = this.bytesDownloaded;
    data["bytesUploaded"] = this.bytesUploaded;
    data["activityId"] = this.activityId;
    data["creditTimeSeconds"] = this.creditTimeSeconds;
    data["secondsPerMB"] = this.secondsPerMB;
    data["modelRevitVersion"] = this.modelRevitVersion;
    data["numberOfRetries"] = this.numberOfRetries;
    data["retryErrors"] = this.retryErrors;
    return data;
  }
}

export interface IJobDataEntry {
  runData?: JobRunDataEntry;
  workItem?: WorkItemDto | undefined;
  id?: string;
  modelStatus?: string;
  sourceModelId?: string;
  sourceFileNameWithExtension?: string;
  sourceDirectoryId?: string;
  sourceDirectoryName?: string | undefined;
  sourceFileSize?: number;
  sourceFileModifiedTime?: Date | undefined;
  createdDate?: Date | undefined;
  updatedDate?: Date | undefined;
  modifiedDate?: Date | undefined;
  errorCode?: string | undefined;
  errorMessage?: string | undefined;
  developerErrorMessage?: string | undefined;
  fullErrorInfo?: string | undefined;
  workItemId?: string | undefined;
  progress?: string | undefined;
  logUri?: string | undefined;
  timeDownloadStarted?: Date | undefined;
  timeInstructionsEnded?: Date | undefined;
  timeInstructionsStarted?: Date | undefined;
  timeQueued?: Date | undefined;
  timeUploadEnded?: Date | undefined;
  timeFinished?: Date | undefined;
  bytesDownloaded?: number | undefined;
  bytesUploaded?: number | undefined;
  activityId?: string | undefined;
  creditTimeSeconds?: number | undefined;
  secondsPerMB?: number | undefined;
  modelRevitVersion?: string | undefined;
  numberOfRetries?: number;
  retryErrors?: string | undefined;
}

export class DeckardJobDataEntry extends JobDataEntry implements IDeckardJobDataEntry {
  runData?: DeckardJobRunDataEntry;
  requestType?: string | undefined;
  sourceZippedFilename?: string | undefined;
  sourceZippedFileSize?: number | undefined;
  sourceZippedFileModifiedTime?: Date | undefined;
  destinationModelId?: string | undefined;
  destinationFileNameWithExtension?: string | undefined;
  destinationFileModifiedTime?: Date | undefined;
  destinationFileSize?: number | undefined;
  destinationDirectoryId?: string | undefined;
  destinationDirectoryName?: string | undefined;
  warnings?: string | undefined;

  constructor(data?: IDeckardJobDataEntry) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.runData = _data["runData"] ? DeckardJobRunDataEntry.fromJS(_data["runData"]) : undefined as any;
      this.requestType = _data["requestType"];
      this.sourceZippedFilename = _data["sourceZippedFilename"];
      this.sourceZippedFileSize = _data["sourceZippedFileSize"];
      this.sourceZippedFileModifiedTime = _data["sourceZippedFileModifiedTime"] ? new Date(_data["sourceZippedFileModifiedTime"].toString()) : undefined as any;
      this.destinationModelId = _data["destinationModelId"];
      this.destinationFileNameWithExtension = _data["destinationFileNameWithExtension"];
      this.destinationFileModifiedTime = _data["destinationFileModifiedTime"] ? new Date(_data["destinationFileModifiedTime"].toString()) : undefined as any;
      this.destinationFileSize = _data["destinationFileSize"];
      this.destinationDirectoryId = _data["destinationDirectoryId"];
      this.destinationDirectoryName = _data["destinationDirectoryName"];
      this.warnings = _data["warnings"];
    }
  }

  static override fromJS(data: any): DeckardJobDataEntry {
    data = typeof data === 'object' ? data : {};
    let result = new DeckardJobDataEntry();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["runData"] = this.runData ? this.runData.toJSON() : undefined as any;
    data["requestType"] = this.requestType;
    data["sourceZippedFilename"] = this.sourceZippedFilename;
    data["sourceZippedFileSize"] = this.sourceZippedFileSize;
    data["sourceZippedFileModifiedTime"] = this.sourceZippedFileModifiedTime ? this.sourceZippedFileModifiedTime.toISOString() : undefined as any;
    data["destinationModelId"] = this.destinationModelId;
    data["destinationFileNameWithExtension"] = this.destinationFileNameWithExtension;
    data["destinationFileModifiedTime"] = this.destinationFileModifiedTime ? this.destinationFileModifiedTime.toISOString() : undefined as any;
    data["destinationFileSize"] = this.destinationFileSize;
    data["destinationDirectoryId"] = this.destinationDirectoryId;
    data["destinationDirectoryName"] = this.destinationDirectoryName;
    data["warnings"] = this.warnings;
    super.toJSON(data);
    return data;
  }
}

export interface IDeckardJobDataEntry extends IJobDataEntry {
  runData?: DeckardJobRunDataEntry;
  requestType?: string | undefined;
  sourceZippedFilename?: string | undefined;
  sourceZippedFileSize?: number | undefined;
  sourceZippedFileModifiedTime?: Date | undefined;
  destinationModelId?: string | undefined;
  destinationFileNameWithExtension?: string | undefined;
  destinationFileModifiedTime?: Date | undefined;
  destinationFileSize?: number | undefined;
  destinationDirectoryId?: string | undefined;
  destinationDirectoryName?: string | undefined;
  warnings?: string | undefined;
}

export class JobRunDataEntry implements IJobRunDataEntry {
  runStatus?: string;
  jobStatus?: string;
  jobRunId?: string;
  jobId?: string;
  jobName?: string;
  jobDescription?: string | undefined;
  customerId?: string;
  customerName?: string;
  userId?: string;
  username?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  sourceRunFileCount?: number;
  sourceProjectId?: string;
  sourceProjectName?: string;
  sourceProjectType?: string;
  sourceHubId?: string;
  sourceHubName?: string;
  sourceRegion?: string;
  sourceHubType?: string;
  runCreatedDate?: Date | undefined;
  runUpdatedDate?: Date | undefined;
  runModifiedDate?: Date | undefined;
  scheduleType?: string;
  jobRunScheduledStartTime?: Date | undefined;
  jobRunActualStartTime?: Date | undefined;
  jobRunActualEndTime?: Date | undefined;
  webhookId?: string | undefined;
  jobRunDuration?: string | undefined;

  constructor(data?: IJobRunDataEntry) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.runStatus = _data["runStatus"];
      this.jobStatus = _data["jobStatus"];
      this.jobRunId = _data["jobRunId"];
      this.jobId = _data["jobId"];
      this.jobName = _data["jobName"];
      this.jobDescription = _data["jobDescription"];
      this.customerId = _data["customerId"];
      this.customerName = _data["customerName"];
      this.userId = _data["userId"];
      this.username = _data["username"];
      this.email = _data["email"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.sourceRunFileCount = _data["sourceRunFileCount"];
      this.sourceProjectId = _data["sourceProjectId"];
      this.sourceProjectName = _data["sourceProjectName"];
      this.sourceProjectType = _data["sourceProjectType"];
      this.sourceHubId = _data["sourceHubId"];
      this.sourceHubName = _data["sourceHubName"];
      this.sourceRegion = _data["sourceRegion"];
      this.sourceHubType = _data["sourceHubType"];
      this.runCreatedDate = _data["runCreatedDate"] ? new Date(_data["runCreatedDate"].toString()) : undefined as any;
      this.runUpdatedDate = _data["runUpdatedDate"] ? new Date(_data["runUpdatedDate"].toString()) : undefined as any;
      this.runModifiedDate = _data["runModifiedDate"] ? new Date(_data["runModifiedDate"].toString()) : undefined as any;
      this.scheduleType = _data["scheduleType"];
      this.jobRunScheduledStartTime = _data["jobRunScheduledStartTime"] ? new Date(_data["jobRunScheduledStartTime"].toString()) : undefined as any;
      this.jobRunActualStartTime = _data["jobRunActualStartTime"] ? new Date(_data["jobRunActualStartTime"].toString()) : undefined as any;
      this.jobRunActualEndTime = _data["jobRunActualEndTime"] ? new Date(_data["jobRunActualEndTime"].toString()) : undefined as any;
      this.webhookId = _data["webhookId"];
      this.jobRunDuration = _data["jobRunDuration"];
    }
  }

  static fromJS(data: any): JobRunDataEntry {
    data = typeof data === 'object' ? data : {};
    let result = new JobRunDataEntry();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["runStatus"] = this.runStatus;
    data["jobStatus"] = this.jobStatus;
    data["jobRunId"] = this.jobRunId;
    data["jobId"] = this.jobId;
    data["jobName"] = this.jobName;
    data["jobDescription"] = this.jobDescription;
    data["customerId"] = this.customerId;
    data["customerName"] = this.customerName;
    data["userId"] = this.userId;
    data["username"] = this.username;
    data["email"] = this.email;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["sourceRunFileCount"] = this.sourceRunFileCount;
    data["sourceProjectId"] = this.sourceProjectId;
    data["sourceProjectName"] = this.sourceProjectName;
    data["sourceProjectType"] = this.sourceProjectType;
    data["sourceHubId"] = this.sourceHubId;
    data["sourceHubName"] = this.sourceHubName;
    data["sourceRegion"] = this.sourceRegion;
    data["sourceHubType"] = this.sourceHubType;
    data["runCreatedDate"] = this.runCreatedDate ? this.runCreatedDate.toISOString() : undefined as any;
    data["runUpdatedDate"] = this.runUpdatedDate ? this.runUpdatedDate.toISOString() : undefined as any;
    data["runModifiedDate"] = this.runModifiedDate ? this.runModifiedDate.toISOString() : undefined as any;
    data["scheduleType"] = this.scheduleType;
    data["jobRunScheduledStartTime"] = this.jobRunScheduledStartTime ? this.jobRunScheduledStartTime.toISOString() : undefined as any;
    data["jobRunActualStartTime"] = this.jobRunActualStartTime ? this.jobRunActualStartTime.toISOString() : undefined as any;
    data["jobRunActualEndTime"] = this.jobRunActualEndTime ? this.jobRunActualEndTime.toISOString() : undefined as any;
    data["webhookId"] = this.webhookId;
    data["jobRunDuration"] = this.jobRunDuration;
    return data;
  }
}

export interface IJobRunDataEntry {
  runStatus?: string;
  jobStatus?: string;
  jobRunId?: string;
  jobId?: string;
  jobName?: string;
  jobDescription?: string | undefined;
  customerId?: string;
  customerName?: string;
  userId?: string;
  username?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  sourceRunFileCount?: number;
  sourceProjectId?: string;
  sourceProjectName?: string;
  sourceProjectType?: string;
  sourceHubId?: string;
  sourceHubName?: string;
  sourceRegion?: string;
  sourceHubType?: string;
  runCreatedDate?: Date | undefined;
  runUpdatedDate?: Date | undefined;
  runModifiedDate?: Date | undefined;
  scheduleType?: string;
  jobRunScheduledStartTime?: Date | undefined;
  jobRunActualStartTime?: Date | undefined;
  jobRunActualEndTime?: Date | undefined;
  webhookId?: string | undefined;
  jobRunDuration?: string | undefined;
}

export class DeckardJobRunDataEntry extends JobRunDataEntry implements IDeckardJobRunDataEntry {
  extractLocationType?: string | undefined;
  destinationNamingType?: string | undefined;
  destinationRunFileCount?: number | undefined;
  destinationRegion?: string | undefined;
  destinationHubId?: string | undefined;
  destinationHubName?: string | undefined;
  destinationHubType?: string | undefined;
  destinationProjectId?: string | undefined;
  destinationProjectName?: string | undefined;
  destinationProjectType?: string | undefined;
  destinationStorageType?: string | undefined;
  bulkTaskId?: string | undefined;
  sourceRevitProjectVersion?: string | undefined;
  destinationRevitProjectVersion?: string | undefined;

  constructor(data?: IDeckardJobRunDataEntry) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.extractLocationType = _data["extractLocationType"];
      this.destinationNamingType = _data["destinationNamingType"];
      this.destinationRunFileCount = _data["destinationRunFileCount"];
      this.destinationRegion = _data["destinationRegion"];
      this.destinationHubId = _data["destinationHubId"];
      this.destinationHubName = _data["destinationHubName"];
      this.destinationHubType = _data["destinationHubType"];
      this.destinationProjectId = _data["destinationProjectId"];
      this.destinationProjectName = _data["destinationProjectName"];
      this.destinationProjectType = _data["destinationProjectType"];
      this.destinationStorageType = _data["destinationStorageType"];
      this.bulkTaskId = _data["bulkTaskId"];
      this.sourceRevitProjectVersion = _data["sourceRevitProjectVersion"];
      this.destinationRevitProjectVersion = _data["destinationRevitProjectVersion"];
    }
  }

  static override fromJS(data: any): DeckardJobRunDataEntry {
    data = typeof data === 'object' ? data : {};
    let result = new DeckardJobRunDataEntry();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["extractLocationType"] = this.extractLocationType;
    data["destinationNamingType"] = this.destinationNamingType;
    data["destinationRunFileCount"] = this.destinationRunFileCount;
    data["destinationRegion"] = this.destinationRegion;
    data["destinationHubId"] = this.destinationHubId;
    data["destinationHubName"] = this.destinationHubName;
    data["destinationHubType"] = this.destinationHubType;
    data["destinationProjectId"] = this.destinationProjectId;
    data["destinationProjectName"] = this.destinationProjectName;
    data["destinationProjectType"] = this.destinationProjectType;
    data["destinationStorageType"] = this.destinationStorageType;
    data["bulkTaskId"] = this.bulkTaskId;
    data["sourceRevitProjectVersion"] = this.sourceRevitProjectVersion;
    data["destinationRevitProjectVersion"] = this.destinationRevitProjectVersion;
    super.toJSON(data);
    return data;
  }
}

export interface IDeckardJobRunDataEntry extends IJobRunDataEntry {
  extractLocationType?: string | undefined;
  destinationNamingType?: string | undefined;
  destinationRunFileCount?: number | undefined;
  destinationRegion?: string | undefined;
  destinationHubId?: string | undefined;
  destinationHubName?: string | undefined;
  destinationHubType?: string | undefined;
  destinationProjectId?: string | undefined;
  destinationProjectName?: string | undefined;
  destinationProjectType?: string | undefined;
  destinationStorageType?: string | undefined;
  bulkTaskId?: string | undefined;
  sourceRevitProjectVersion?: string | undefined;
  destinationRevitProjectVersion?: string | undefined;
}

export class PaginationData implements IPaginationData {
  paginationToken?: string | undefined;
  limit?: number;

  constructor(data?: IPaginationData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.paginationToken = _data["paginationToken"];
      this.limit = _data["limit"];
    }
  }

  static fromJS(data: any): PaginationData {
    data = typeof data === 'object' ? data : {};
    let result = new PaginationData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["paginationToken"] = this.paginationToken;
    data["limit"] = this.limit;
    return data;
  }
}

export interface IPaginationData {
  paginationToken?: string | undefined;
  limit?: number;
}

export enum UsageSortType {
  Default = "Default",
  Date = "Date",
}

export enum UsageExportType {
  Items = "Items",
  Runs = "Runs",
}

export enum UsageExportFormat {
  Csv = "Csv",
  Parquet = "Parquet",
}

export class UsageSummaryBase extends UsageBase implements IUsageSummaryBase {
  data?: OverallUsageDataBase;
  filter?: UsageFilter;
  requestTime?: Date;
  jobRuns?: JobRunBase[];

  constructor(data?: IUsageSummaryBase) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.data = _data["data"] ? OverallUsageDataBase.fromJS(_data["data"]) : undefined as any;
      this.filter = _data["filter"] ? UsageFilter.fromJS(_data["filter"]) : undefined as any;
      this.requestTime = _data["requestTime"] ? new Date(_data["requestTime"].toString()) : undefined as any;
      if (Array.isArray(_data["jobRuns"])) {
        this.jobRuns = [] as any;
        for (let item of _data["jobRuns"])
          this.jobRuns!.push(JobRunBase.fromJS(item));
      }
    }
  }

  static override fromJS(data: any): UsageSummaryBase {
    data = typeof data === 'object' ? data : {};
    let result = new UsageSummaryBase();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["data"] = this.data ? this.data.toJSON() : undefined as any;
    data["filter"] = this.filter ? this.filter.toJSON() : undefined as any;
    data["requestTime"] = this.requestTime ? this.requestTime.toISOString() : undefined as any;
    if (Array.isArray(this.jobRuns)) {
      data["jobRuns"] = [];
      for (let item of this.jobRuns)
        data["jobRuns"].push(item ? item.toJSON() : undefined as any);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IUsageSummaryBase extends IUsageBase {
  data?: OverallUsageDataBase;
  filter?: UsageFilter;
  requestTime?: Date;
  jobRuns?: JobRunBase[];
}

export class UsageSummary extends UsageSummaryBase implements IUsageSummary {
  data?: OverallUsageData;

  constructor(data?: IUsageSummary) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.data = _data["data"] ? OverallUsageData.fromJS(_data["data"]) : undefined as any;
    }
  }

  static override fromJS(data: any): UsageSummary {
    data = typeof data === 'object' ? data : {};
    let result = new UsageSummary();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["data"] = this.data ? this.data.toJSON() : undefined as any;
    super.toJSON(data);
    return data;
  }
}

export interface IUsageSummary extends IUsageSummaryBase {
  data?: OverallUsageData;
}

export class OverallUsageDataBase implements IOverallUsageDataBase {
  jobRunCount?: number;
  level?: UsageDataLevel;
  runTimeSeconds?: number;
  customerUsageDatas?: CustomerUsageDataBase[];

  constructor(data?: IOverallUsageDataBase) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.jobRunCount = _data["jobRunCount"];
      this.level = _data["level"];
      this.runTimeSeconds = _data["runTimeSeconds"];
      if (Array.isArray(_data["customerUsageDatas"])) {
        this.customerUsageDatas = [] as any;
        for (let item of _data["customerUsageDatas"])
          this.customerUsageDatas!.push(CustomerUsageDataBase.fromJS(item));
      }
    }
  }

  static fromJS(data: any): OverallUsageDataBase {
    data = typeof data === 'object' ? data : {};
    let result = new OverallUsageDataBase();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["jobRunCount"] = this.jobRunCount;
    data["level"] = this.level;
    data["runTimeSeconds"] = this.runTimeSeconds;
    if (Array.isArray(this.customerUsageDatas)) {
      data["customerUsageDatas"] = [];
      for (let item of this.customerUsageDatas)
        data["customerUsageDatas"].push(item ? item.toJSON() : undefined as any);
    }
    return data;
  }
}

export interface IOverallUsageDataBase {
  jobRunCount?: number;
  level?: UsageDataLevel;
  runTimeSeconds?: number;
  customerUsageDatas?: CustomerUsageDataBase[];
}

export class OverallUsageData extends OverallUsageDataBase implements IOverallUsageData {
  customerUsageDatas?: CustomerUsageData[];
  totalFiles?: number;
  successFiles?: number;
  failedFiles?: number;
  pendingFiles?: number;

  constructor(data?: IOverallUsageData) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["customerUsageDatas"])) {
        this.customerUsageDatas = [] as any;
        for (let item of _data["customerUsageDatas"])
          this.customerUsageDatas!.push(CustomerUsageData.fromJS(item));
      }
      this.totalFiles = _data["totalFiles"];
      this.successFiles = _data["successFiles"];
      this.failedFiles = _data["failedFiles"];
      this.pendingFiles = _data["pendingFiles"];
    }
  }

  static override fromJS(data: any): OverallUsageData {
    data = typeof data === 'object' ? data : {};
    let result = new OverallUsageData();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.customerUsageDatas)) {
      data["customerUsageDatas"] = [];
      for (let item of this.customerUsageDatas)
        data["customerUsageDatas"].push(item ? item.toJSON() : undefined as any);
    }
    data["totalFiles"] = this.totalFiles;
    data["successFiles"] = this.successFiles;
    data["failedFiles"] = this.failedFiles;
    data["pendingFiles"] = this.pendingFiles;
    super.toJSON(data);
    return data;
  }
}

export interface IOverallUsageData extends IOverallUsageDataBase {
  customerUsageDatas?: CustomerUsageData[];
  totalFiles?: number;
  successFiles?: number;
  failedFiles?: number;
  pendingFiles?: number;
}

export class CustomerUsageDataBase implements ICustomerUsageDataBase {
  customerId?: string;
  customerName?: string;
  jobRunCount?: number;
  level?: UsageDataLevel;
  runTimeSeconds?: number;
  userUsageDatas?: UserUsageDataBase[];

  constructor(data?: ICustomerUsageDataBase) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.customerId = _data["customerId"];
      this.customerName = _data["customerName"];
      this.jobRunCount = _data["jobRunCount"];
      this.level = _data["level"];
      this.runTimeSeconds = _data["runTimeSeconds"];
      if (Array.isArray(_data["userUsageDatas"])) {
        this.userUsageDatas = [] as any;
        for (let item of _data["userUsageDatas"])
          this.userUsageDatas!.push(UserUsageDataBase.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CustomerUsageDataBase {
    data = typeof data === 'object' ? data : {};
    let result = new CustomerUsageDataBase();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["customerId"] = this.customerId;
    data["customerName"] = this.customerName;
    data["jobRunCount"] = this.jobRunCount;
    data["level"] = this.level;
    data["runTimeSeconds"] = this.runTimeSeconds;
    if (Array.isArray(this.userUsageDatas)) {
      data["userUsageDatas"] = [];
      for (let item of this.userUsageDatas)
        data["userUsageDatas"].push(item ? item.toJSON() : undefined as any);
    }
    return data;
  }
}

export interface ICustomerUsageDataBase {
  customerId?: string;
  customerName?: string;
  jobRunCount?: number;
  level?: UsageDataLevel;
  runTimeSeconds?: number;
  userUsageDatas?: UserUsageDataBase[];
}

export class CustomerUsageData extends CustomerUsageDataBase implements ICustomerUsageData {
  userUsageDatas?: UserUsageData[];
  totalFiles?: number;
  successFiles?: number;
  failedFiles?: number;
  pendingFiles?: number;

  constructor(data?: ICustomerUsageData) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["userUsageDatas"])) {
        this.userUsageDatas = [] as any;
        for (let item of _data["userUsageDatas"])
          this.userUsageDatas!.push(UserUsageData.fromJS(item));
      }
      this.totalFiles = _data["totalFiles"];
      this.successFiles = _data["successFiles"];
      this.failedFiles = _data["failedFiles"];
      this.pendingFiles = _data["pendingFiles"];
    }
  }

  static override fromJS(data: any): CustomerUsageData {
    data = typeof data === 'object' ? data : {};
    let result = new CustomerUsageData();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.userUsageDatas)) {
      data["userUsageDatas"] = [];
      for (let item of this.userUsageDatas)
        data["userUsageDatas"].push(item ? item.toJSON() : undefined as any);
    }
    data["totalFiles"] = this.totalFiles;
    data["successFiles"] = this.successFiles;
    data["failedFiles"] = this.failedFiles;
    data["pendingFiles"] = this.pendingFiles;
    super.toJSON(data);
    return data;
  }
}

export interface ICustomerUsageData extends ICustomerUsageDataBase {
  userUsageDatas?: UserUsageData[];
  totalFiles?: number;
  successFiles?: number;
  failedFiles?: number;
  pendingFiles?: number;
}

export class UserUsageDataBase implements IUserUsageDataBase {
  userId?: string;
  username?: string;
  jobRunCount?: number;
  level?: UsageDataLevel;
  runTimeSeconds?: number;
  jobUsageDatas?: JobUsageDataBase[];

  constructor(data?: IUserUsageDataBase) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data["userId"];
      this.username = _data["username"];
      this.jobRunCount = _data["jobRunCount"];
      this.level = _data["level"];
      this.runTimeSeconds = _data["runTimeSeconds"];
      if (Array.isArray(_data["jobUsageDatas"])) {
        this.jobUsageDatas = [] as any;
        for (let item of _data["jobUsageDatas"])
          this.jobUsageDatas!.push(JobUsageDataBase.fromJS(item));
      }
    }
  }

  static fromJS(data: any): UserUsageDataBase {
    data = typeof data === 'object' ? data : {};
    let result = new UserUsageDataBase();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["userId"] = this.userId;
    data["username"] = this.username;
    data["jobRunCount"] = this.jobRunCount;
    data["level"] = this.level;
    data["runTimeSeconds"] = this.runTimeSeconds;
    if (Array.isArray(this.jobUsageDatas)) {
      data["jobUsageDatas"] = [];
      for (let item of this.jobUsageDatas)
        data["jobUsageDatas"].push(item ? item.toJSON() : undefined as any);
    }
    return data;
  }
}

export interface IUserUsageDataBase {
  userId?: string;
  username?: string;
  jobRunCount?: number;
  level?: UsageDataLevel;
  runTimeSeconds?: number;
  jobUsageDatas?: JobUsageDataBase[];
}

export class UserUsageData extends UserUsageDataBase implements IUserUsageData {
  jobUsageDatas?: JobUsageData[];
  totalFiles?: number;
  successFiles?: number;
  failedFiles?: number;
  pendingFiles?: number;

  constructor(data?: IUserUsageData) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["jobUsageDatas"])) {
        this.jobUsageDatas = [] as any;
        for (let item of _data["jobUsageDatas"])
          this.jobUsageDatas!.push(JobUsageData.fromJS(item));
      }
      this.totalFiles = _data["totalFiles"];
      this.successFiles = _data["successFiles"];
      this.failedFiles = _data["failedFiles"];
      this.pendingFiles = _data["pendingFiles"];
    }
  }

  static override fromJS(data: any): UserUsageData {
    data = typeof data === 'object' ? data : {};
    let result = new UserUsageData();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.jobUsageDatas)) {
      data["jobUsageDatas"] = [];
      for (let item of this.jobUsageDatas)
        data["jobUsageDatas"].push(item ? item.toJSON() : undefined as any);
    }
    data["totalFiles"] = this.totalFiles;
    data["successFiles"] = this.successFiles;
    data["failedFiles"] = this.failedFiles;
    data["pendingFiles"] = this.pendingFiles;
    super.toJSON(data);
    return data;
  }
}

export interface IUserUsageData extends IUserUsageDataBase {
  jobUsageDatas?: JobUsageData[];
  totalFiles?: number;
  successFiles?: number;
  failedFiles?: number;
  pendingFiles?: number;
}

export class JobUsageDataBase implements IJobUsageDataBase {
  jobId?: string;
  jobName?: string;
  jobRunCount?: number;
  level?: UsageDataLevel;
  runTimeSeconds?: number;

  constructor(data?: IJobUsageDataBase) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.jobId = _data["jobId"];
      this.jobName = _data["jobName"];
      this.jobRunCount = _data["jobRunCount"];
      this.level = _data["level"];
      this.runTimeSeconds = _data["runTimeSeconds"];
    }
  }

  static fromJS(data: any): JobUsageDataBase {
    data = typeof data === 'object' ? data : {};
    let result = new JobUsageDataBase();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["jobId"] = this.jobId;
    data["jobName"] = this.jobName;
    data["jobRunCount"] = this.jobRunCount;
    data["level"] = this.level;
    data["runTimeSeconds"] = this.runTimeSeconds;
    return data;
  }
}

export interface IJobUsageDataBase {
  jobId?: string;
  jobName?: string;
  jobRunCount?: number;
  level?: UsageDataLevel;
  runTimeSeconds?: number;
}

export class JobUsageData extends JobUsageDataBase implements IJobUsageData {
  totalFiles?: number;
  successFiles?: number;
  failedFiles?: number;
  pendingFiles?: number;

  constructor(data?: IJobUsageData) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.totalFiles = _data["totalFiles"];
      this.successFiles = _data["successFiles"];
      this.failedFiles = _data["failedFiles"];
      this.pendingFiles = _data["pendingFiles"];
    }
  }

  static override fromJS(data: any): JobUsageData {
    data = typeof data === 'object' ? data : {};
    let result = new JobUsageData();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["totalFiles"] = this.totalFiles;
    data["successFiles"] = this.successFiles;
    data["failedFiles"] = this.failedFiles;
    data["pendingFiles"] = this.pendingFiles;
    super.toJSON(data);
    return data;
  }
}

export interface IJobUsageData extends IJobUsageDataBase {
  totalFiles?: number;
  successFiles?: number;
  failedFiles?: number;
  pendingFiles?: number;
}

export enum UsageDataLevel {
  All = "All",
  Customer = "Customer",
  User = "User",
  Job = "Job",
}

export class UsageFilter implements IUsageFilter {
  customer?: CustomerInfo[];
  user?: UserBase[];
  job?: JobBase[];
  startDate?: Date | undefined;
  endDate?: Date | undefined;

  constructor(data?: IUsageFilter) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["customer"])) {
        this.customer = [] as any;
        for (let item of _data["customer"])
          this.customer!.push(CustomerInfo.fromJS(item));
      }
      if (Array.isArray(_data["user"])) {
        this.user = [] as any;
        for (let item of _data["user"])
          this.user!.push(UserBase.fromJS(item));
      }
      if (Array.isArray(_data["job"])) {
        this.job = [] as any;
        for (let item of _data["job"])
          this.job!.push(JobBase.fromJS(item));
      }
      this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
      this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
    }
  }

  static fromJS(data: any): UsageFilter {
    data = typeof data === 'object' ? data : {};
    let result = new UsageFilter();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.customer)) {
      data["customer"] = [];
      for (let item of this.customer)
        data["customer"].push(item ? item.toJSON() : undefined as any);
    }
    if (Array.isArray(this.user)) {
      data["user"] = [];
      for (let item of this.user)
        data["user"].push(item ? item.toJSON() : undefined as any);
    }
    if (Array.isArray(this.job)) {
      data["job"] = [];
      for (let item of this.job)
        data["job"].push(item ? item.toJSON() : undefined as any);
    }
    data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
    data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
    return data;
  }
}

export interface IUsageFilter {
  customer?: CustomerInfo[];
  user?: UserBase[];
  job?: JobBase[];
  startDate?: Date | undefined;
  endDate?: Date | undefined;
}

export class StartUsageDownloadResult implements IStartUsageDownloadResult {
  id?: string;

  constructor(data?: IStartUsageDownloadResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): StartUsageDownloadResult {
    data = typeof data === 'object' ? data : {};
    let result = new StartUsageDownloadResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    return data;
  }
}

export interface IStartUsageDownloadResult {
  id?: string;
}

export class OutgoingWebhook implements IOutgoingWebhook {
  id?: string;
  url?: string;
  scope?: OutgoingWebhookScopeType;
  scopeId?: string;
  userId?: string;
  customerId?: string;
  lastEvent?: OutgoingWebhookEvent | undefined;
  eventType?: OutgoingWebhookEventType;
  isEnabled?: boolean;
  displayName?: string | undefined;

  constructor(data?: IOutgoingWebhook) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.url = _data["url"];
      this.scope = _data["scope"];
      this.scopeId = _data["scopeId"];
      this.userId = _data["userId"];
      this.customerId = _data["customerId"];
      this.lastEvent = _data["lastEvent"] ? OutgoingWebhookEvent.fromJS(_data["lastEvent"]) : undefined as any;
      this.eventType = _data["eventType"];
      this.isEnabled = _data["isEnabled"];
      this.displayName = _data["displayName"];
    }
  }

  static fromJS(data: any): OutgoingWebhook {
    data = typeof data === 'object' ? data : {};
    let result = new OutgoingWebhook();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["url"] = this.url;
    data["scope"] = this.scope;
    data["scopeId"] = this.scopeId;
    data["userId"] = this.userId;
    data["customerId"] = this.customerId;
    data["lastEvent"] = this.lastEvent ? this.lastEvent.toJSON() : undefined as any;
    data["eventType"] = this.eventType;
    data["isEnabled"] = this.isEnabled;
    data["displayName"] = this.displayName;
    return data;
  }
}

export interface IOutgoingWebhook {
  id?: string;
  url?: string;
  scope?: OutgoingWebhookScopeType;
  scopeId?: string;
  userId?: string;
  customerId?: string;
  lastEvent?: OutgoingWebhookEvent | undefined;
  eventType?: OutgoingWebhookEventType;
  isEnabled?: boolean;
  displayName?: string | undefined;
}

export enum OutgoingWebhookScopeType {
  None = "None",
  Job = "Job",
  User = "User",
  Customer = "Customer",
  File = "File",
  Folder = "Folder",
  Project = "Project",
  Hub = "Hub",
}

export class OutgoingWebhookEvent implements IOutgoingWebhookEvent {
  id?: string;
  webhookId?: string;
  webhookEventNumber?: number;
  url?: string;
  scope?: OutgoingWebhookScopeType;
  scopeId?: string;
  success?: boolean;
  isComplete?: boolean;
  statusCode?: number;
  retryCount?: number;
  sendAttempts?: OutgoingWebhookSendAttempt[];
  sendAttemptsLoaded?: boolean;

  constructor(data?: IOutgoingWebhookEvent) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.webhookId = _data["webhookId"];
      this.webhookEventNumber = _data["webhookEventNumber"];
      this.url = _data["url"];
      this.scope = _data["scope"];
      this.scopeId = _data["scopeId"];
      this.success = _data["success"];
      this.isComplete = _data["isComplete"];
      this.statusCode = _data["statusCode"];
      this.retryCount = _data["retryCount"];
      if (Array.isArray(_data["sendAttempts"])) {
        this.sendAttempts = [] as any;
        for (let item of _data["sendAttempts"])
          this.sendAttempts!.push(OutgoingWebhookSendAttempt.fromJS(item));
      }
      this.sendAttemptsLoaded = _data["sendAttemptsLoaded"];
    }
  }

  static fromJS(data: any): OutgoingWebhookEvent {
    data = typeof data === 'object' ? data : {};
    let result = new OutgoingWebhookEvent();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["webhookId"] = this.webhookId;
    data["webhookEventNumber"] = this.webhookEventNumber;
    data["url"] = this.url;
    data["scope"] = this.scope;
    data["scopeId"] = this.scopeId;
    data["success"] = this.success;
    data["isComplete"] = this.isComplete;
    data["statusCode"] = this.statusCode;
    data["retryCount"] = this.retryCount;
    if (Array.isArray(this.sendAttempts)) {
      data["sendAttempts"] = [];
      for (let item of this.sendAttempts)
        data["sendAttempts"].push(item ? item.toJSON() : undefined as any);
    }
    data["sendAttemptsLoaded"] = this.sendAttemptsLoaded;
    return data;
  }
}

export interface IOutgoingWebhookEvent {
  id?: string;
  webhookId?: string;
  webhookEventNumber?: number;
  url?: string;
  scope?: OutgoingWebhookScopeType;
  scopeId?: string;
  success?: boolean;
  isComplete?: boolean;
  statusCode?: number;
  retryCount?: number;
  sendAttempts?: OutgoingWebhookSendAttempt[];
  sendAttemptsLoaded?: boolean;
}

export class OutgoingWebhookSendAttempt implements IOutgoingWebhookSendAttempt {
  webhookId?: string;
  webhookTaskId?: string;
  webhookSendAttemptId?: string;
  webhookExecutionId?: string;
  success?: boolean;
  statusCode?: number;
  response?: string | undefined;
  errorMessage?: string | undefined;
  attemptNumber?: number;
  executionNumber?: number;
  sendTime?: Date;

  constructor(data?: IOutgoingWebhookSendAttempt) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.webhookId = _data["webhookId"];
      this.webhookTaskId = _data["webhookTaskId"];
      this.webhookSendAttemptId = _data["webhookSendAttemptId"];
      this.webhookExecutionId = _data["webhookExecutionId"];
      this.success = _data["success"];
      this.statusCode = _data["statusCode"];
      this.response = _data["response"];
      this.errorMessage = _data["errorMessage"];
      this.attemptNumber = _data["attemptNumber"];
      this.executionNumber = _data["executionNumber"];
      this.sendTime = _data["sendTime"] ? new Date(_data["sendTime"].toString()) : undefined as any;
    }
  }

  static fromJS(data: any): OutgoingWebhookSendAttempt {
    data = typeof data === 'object' ? data : {};
    let result = new OutgoingWebhookSendAttempt();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["webhookId"] = this.webhookId;
    data["webhookTaskId"] = this.webhookTaskId;
    data["webhookSendAttemptId"] = this.webhookSendAttemptId;
    data["webhookExecutionId"] = this.webhookExecutionId;
    data["success"] = this.success;
    data["statusCode"] = this.statusCode;
    data["response"] = this.response;
    data["errorMessage"] = this.errorMessage;
    data["attemptNumber"] = this.attemptNumber;
    data["executionNumber"] = this.executionNumber;
    data["sendTime"] = this.sendTime ? this.sendTime.toISOString() : undefined as any;
    return data;
  }
}

export interface IOutgoingWebhookSendAttempt {
  webhookId?: string;
  webhookTaskId?: string;
  webhookSendAttemptId?: string;
  webhookExecutionId?: string;
  success?: boolean;
  statusCode?: number;
  response?: string | undefined;
  errorMessage?: string | undefined;
  attemptNumber?: number;
  executionNumber?: number;
  sendTime?: Date;
}

export enum OutgoingWebhookEventType {
  None = "None",
  JobComplete = "JobComplete",
}

export class CreateOutgoingWebhookRequest implements ICreateOutgoingWebhookRequest {
  url?: string;
  secretToken?: string;
  scope?: OutgoingWebhookScopeType;
  scopeId?: string;
  eventType?: OutgoingWebhookEventType;
  isEnabled?: boolean;
  displayName?: string | undefined;

  constructor(data?: ICreateOutgoingWebhookRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.url = _data["url"];
      this.secretToken = _data["secretToken"];
      this.scope = _data["scope"];
      this.scopeId = _data["scopeId"];
      this.eventType = _data["eventType"];
      this.isEnabled = _data["isEnabled"];
      this.displayName = _data["displayName"];
    }
  }

  static fromJS(data: any): CreateOutgoingWebhookRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOutgoingWebhookRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["url"] = this.url;
    data["secretToken"] = this.secretToken;
    data["scope"] = this.scope;
    data["scopeId"] = this.scopeId;
    data["eventType"] = this.eventType;
    data["isEnabled"] = this.isEnabled;
    data["displayName"] = this.displayName;
    return data;
  }
}

export interface ICreateOutgoingWebhookRequest {
  url?: string;
  secretToken?: string;
  scope?: OutgoingWebhookScopeType;
  scopeId?: string;
  eventType?: OutgoingWebhookEventType;
  isEnabled?: boolean;
  displayName?: string | undefined;
}

export class EditOutgoingWebhookRequest implements IEditOutgoingWebhookRequest {
  url?: string | undefined;
  secretToken?: string | undefined;
  scope?: OutgoingWebhookScopeType | undefined;
  scopeId?: string | undefined;
  eventType?: OutgoingWebhookEventType | undefined;
  isEnabled?: boolean | undefined;
  displayName?: string | undefined;

  constructor(data?: IEditOutgoingWebhookRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.url = _data["url"];
      this.secretToken = _data["secretToken"];
      this.scope = _data["scope"];
      this.scopeId = _data["scopeId"];
      this.eventType = _data["eventType"];
      this.isEnabled = _data["isEnabled"];
      this.displayName = _data["displayName"];
    }
  }

  static fromJS(data: any): EditOutgoingWebhookRequest {
    data = typeof data === 'object' ? data : {};
    let result = new EditOutgoingWebhookRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["url"] = this.url;
    data["secretToken"] = this.secretToken;
    data["scope"] = this.scope;
    data["scopeId"] = this.scopeId;
    data["eventType"] = this.eventType;
    data["isEnabled"] = this.isEnabled;
    data["displayName"] = this.displayName;
    return data;
  }
}

export interface IEditOutgoingWebhookRequest {
  url?: string | undefined;
  secretToken?: string | undefined;
  scope?: OutgoingWebhookScopeType | undefined;
  scopeId?: string | undefined;
  eventType?: OutgoingWebhookEventType | undefined;
  isEnabled?: boolean | undefined;
  displayName?: string | undefined;
}

export class OutgoingWebhookSecret implements IOutgoingWebhookSecret {
  webhookId?: string;
  secret?: string;

  constructor(data?: IOutgoingWebhookSecret) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.webhookId = _data["webhookId"];
      this.secret = _data["secret"];
    }
  }

  static fromJS(data: any): OutgoingWebhookSecret {
    data = typeof data === 'object' ? data : {};
    let result = new OutgoingWebhookSecret();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["webhookId"] = this.webhookId;
    data["secret"] = this.secret;
    return data;
  }
}

export interface IOutgoingWebhookSecret {
  webhookId?: string;
  secret?: string;
}

export class PaginatedCount implements IPaginatedCount {
  paginationData?: PaginationData | undefined;
  count?: number;
  isDone?: boolean;
  errors?: RequestError[];

  constructor(data?: IPaginatedCount) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.paginationData = _data["paginationData"] ? PaginationData.fromJS(_data["paginationData"]) : undefined as any;
      this.count = _data["count"];
      this.isDone = _data["isDone"];
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"])
          this.errors!.push(RequestError.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PaginatedCount {
    data = typeof data === 'object' ? data : {};
    let result = new PaginatedCount();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["paginationData"] = this.paginationData ? this.paginationData.toJSON() : undefined as any;
    data["count"] = this.count;
    data["isDone"] = this.isDone;
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors)
        data["errors"].push(item ? item.toJSON() : undefined as any);
    }
    return data;
  }
}

export interface IPaginatedCount {
  paginationData?: PaginationData | undefined;
  count?: number;
  isDone?: boolean;
  errors?: RequestError[];
}

export class PaginatedResultOfOutgoingWebhookEvent extends PaginatedCount implements IPaginatedResultOfOutgoingWebhookEvent {
  items?: OutgoingWebhookEvent[];

  constructor(data?: IPaginatedResultOfOutgoingWebhookEvent) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(OutgoingWebhookEvent.fromJS(item));
      }
    }
  }

  static override fromJS(data: any): PaginatedResultOfOutgoingWebhookEvent {
    data = typeof data === 'object' ? data : {};
    let result = new PaginatedResultOfOutgoingWebhookEvent();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item ? item.toJSON() : undefined as any);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IPaginatedResultOfOutgoingWebhookEvent extends IPaginatedCount {
  items?: OutgoingWebhookEvent[];
}

export class OutgoingWebhookEventPaginatedResult extends PaginatedResultOfOutgoingWebhookEvent implements IOutgoingWebhookEventPaginatedResult {

  constructor(data?: IOutgoingWebhookEventPaginatedResult) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): OutgoingWebhookEventPaginatedResult {
    data = typeof data === 'object' ? data : {};
    let result = new OutgoingWebhookEventPaginatedResult();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IOutgoingWebhookEventPaginatedResult extends IPaginatedResultOfOutgoingWebhookEvent {
}

export class RequestError implements IRequestError {
  id?: string;
  errorMessage?: string;

  constructor(data?: IRequestError) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.errorMessage = _data["errorMessage"];
    }
  }

  static fromJS(data: any): RequestError {
    data = typeof data === 'object' ? data : {};
    let result = new RequestError();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["errorMessage"] = this.errorMessage;
    return data;
  }
}

export interface IRequestError {
  id?: string;
  errorMessage?: string;
}

export class PaginatedResultOfOutgoingWebhook extends PaginatedCount implements IPaginatedResultOfOutgoingWebhook {
  items?: OutgoingWebhook[];

  constructor(data?: IPaginatedResultOfOutgoingWebhook) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(OutgoingWebhook.fromJS(item));
      }
    }
  }

  static override fromJS(data: any): PaginatedResultOfOutgoingWebhook {
    data = typeof data === 'object' ? data : {};
    let result = new PaginatedResultOfOutgoingWebhook();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item ? item.toJSON() : undefined as any);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IPaginatedResultOfOutgoingWebhook extends IPaginatedCount {
  items?: OutgoingWebhook[];
}

export class OutgoingWebhookPaginatedResult extends PaginatedResultOfOutgoingWebhook implements IOutgoingWebhookPaginatedResult {

  constructor(data?: IOutgoingWebhookPaginatedResult) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): OutgoingWebhookPaginatedResult {
    data = typeof data === 'object' ? data : {};
    let result = new OutgoingWebhookPaginatedResult();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IOutgoingWebhookPaginatedResult extends IPaginatedResultOfOutgoingWebhook {
}

export class OutgoingWebhookBody implements IOutgoingWebhookBody {
  version?: string;
  resource?: string;
  id?: string;
  attempt?: number;
  creationTimeUtc?: Date;
  webhook?: OutgoingWebhookInfo;
  payload?: OutgoingWebhookPayload;

  constructor(data?: IOutgoingWebhookBody) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.version = _data["version"];
      this.resource = _data["resource"];
      this.id = _data["id"];
      this.attempt = _data["attempt"];
      this.creationTimeUtc = _data["creationTimeUtc"] ? new Date(_data["creationTimeUtc"].toString()) : undefined as any;
      this.webhook = _data["webhook"] ? OutgoingWebhookInfo.fromJS(_data["webhook"]) : undefined as any;
      this.payload = _data["payload"] ? OutgoingWebhookPayload.fromJS(_data["payload"]) : undefined as any;
    }
  }

  static fromJS(data: any): OutgoingWebhookBody {
    data = typeof data === 'object' ? data : {};
    let result = new OutgoingWebhookBody();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["version"] = this.version;
    data["resource"] = this.resource;
    data["id"] = this.id;
    data["attempt"] = this.attempt;
    data["creationTimeUtc"] = this.creationTimeUtc ? this.creationTimeUtc.toISOString() : undefined as any;
    data["webhook"] = this.webhook ? this.webhook.toJSON() : undefined as any;
    data["payload"] = this.payload ? this.payload.toJSON() : undefined as any;
    return data;
  }
}

export interface IOutgoingWebhookBody {
  version?: string;
  resource?: string;
  id?: string;
  attempt?: number;
  creationTimeUtc?: Date;
  webhook?: OutgoingWebhookInfo;
  payload?: OutgoingWebhookPayload;
}

export class OutgoingWebhookInfo implements IOutgoingWebhookInfo {
  id?: string;
  webhookEventId?: string;
  webhookId?: string;
  scopeType?: OutgoingWebhookScopeType;
  scopeId?: string;
  eventType?: OutgoingWebhookEventType;
  webhookUri?: string;
  userId?: string;
  customerId?: string;
  creationTimeUtc?: Date;

  constructor(data?: IOutgoingWebhookInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.webhookEventId = _data["webhookEventId"];
      this.webhookId = _data["webhookId"];
      this.scopeType = _data["scopeType"];
      this.scopeId = _data["scopeId"];
      this.eventType = _data["eventType"];
      this.webhookUri = _data["webhookUri"];
      this.userId = _data["userId"];
      this.customerId = _data["customerId"];
      this.creationTimeUtc = _data["creationTimeUtc"] ? new Date(_data["creationTimeUtc"].toString()) : undefined as any;
    }
  }

  static fromJS(data: any): OutgoingWebhookInfo {
    data = typeof data === 'object' ? data : {};
    let result = new OutgoingWebhookInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["webhookEventId"] = this.webhookEventId;
    data["webhookId"] = this.webhookId;
    data["scopeType"] = this.scopeType;
    data["scopeId"] = this.scopeId;
    data["eventType"] = this.eventType;
    data["webhookUri"] = this.webhookUri;
    data["userId"] = this.userId;
    data["customerId"] = this.customerId;
    data["creationTimeUtc"] = this.creationTimeUtc ? this.creationTimeUtc.toISOString() : undefined as any;
    return data;
  }
}

export interface IOutgoingWebhookInfo {
  id?: string;
  webhookEventId?: string;
  webhookId?: string;
  scopeType?: OutgoingWebhookScopeType;
  scopeId?: string;
  eventType?: OutgoingWebhookEventType;
  webhookUri?: string;
  userId?: string;
  customerId?: string;
  creationTimeUtc?: Date;
}

export class OutgoingWebhookPayload implements IOutgoingWebhookPayload {
  job?: OutgoingWebhookJobBody;
  jobRun?: OutgoingWebhookJobRunBody;
  jobRunItems?: OutgoingWebhookJobRunItemBody[];

  constructor(data?: IOutgoingWebhookPayload) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.job = _data["job"] ? OutgoingWebhookJobBody.fromJS(_data["job"]) : undefined as any;
      this.jobRun = _data["jobRun"] ? OutgoingWebhookJobRunBody.fromJS(_data["jobRun"]) : undefined as any;
      if (Array.isArray(_data["jobRunItems"])) {
        this.jobRunItems = [] as any;
        for (let item of _data["jobRunItems"])
          this.jobRunItems!.push(OutgoingWebhookJobRunItemBody.fromJS(item));
      }
    }
  }

  static fromJS(data: any): OutgoingWebhookPayload {
    data = typeof data === 'object' ? data : {};
    let result = new OutgoingWebhookPayload();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["job"] = this.job ? this.job.toJSON() : undefined as any;
    data["jobRun"] = this.jobRun ? this.jobRun.toJSON() : undefined as any;
    if (Array.isArray(this.jobRunItems)) {
      data["jobRunItems"] = [];
      for (let item of this.jobRunItems)
        data["jobRunItems"].push(item ? item.toJSON() : undefined as any);
    }
    return data;
  }
}

export interface IOutgoingWebhookPayload {
  job?: OutgoingWebhookJobBody;
  jobRun?: OutgoingWebhookJobRunBody;
  jobRunItems?: OutgoingWebhookJobRunItemBody[];
}

export class OutgoingWebhookJobBody implements IOutgoingWebhookJobBody {
  jobId?: string;
  jobName?: string;
  scheduleType?: JobScheduleType;
  userId?: string;
  customerId?: string;
  hubId?: string;
  hubName?: string;
  projectId?: string;
  projectName?: string;

  constructor(data?: IOutgoingWebhookJobBody) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.jobId = _data["jobId"];
      this.jobName = _data["jobName"];
      this.scheduleType = _data["scheduleType"];
      this.userId = _data["userId"];
      this.customerId = _data["customerId"];
      this.hubId = _data["hubId"];
      this.hubName = _data["hubName"];
      this.projectId = _data["projectId"];
      this.projectName = _data["projectName"];
    }
  }

  static fromJS(data: any): OutgoingWebhookJobBody {
    data = typeof data === 'object' ? data : {};
    let result = new OutgoingWebhookJobBody();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["jobId"] = this.jobId;
    data["jobName"] = this.jobName;
    data["scheduleType"] = this.scheduleType;
    data["userId"] = this.userId;
    data["customerId"] = this.customerId;
    data["hubId"] = this.hubId;
    data["hubName"] = this.hubName;
    data["projectId"] = this.projectId;
    data["projectName"] = this.projectName;
    return data;
  }
}

export interface IOutgoingWebhookJobBody {
  jobId?: string;
  jobName?: string;
  scheduleType?: JobScheduleType;
  userId?: string;
  customerId?: string;
  hubId?: string;
  hubName?: string;
  projectId?: string;
  projectName?: string;
}

export class OutgoingWebhookJobRunBody implements IOutgoingWebhookJobRunBody {
  jobRunId?: string;
  status?: JobRunStatusType;
  errorMessage?: string | undefined;
  errorCode?: number | undefined;
  startTime?: Date;
  endTime?: Date;
  totalFiles?: number;
  successFiles?: number;
  failedFiles?: number;
  pendingFiles?: number;

  constructor(data?: IOutgoingWebhookJobRunBody) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.jobRunId = _data["jobRunId"];
      this.status = _data["status"];
      this.errorMessage = _data["errorMessage"];
      this.errorCode = _data["errorCode"];
      this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
      this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
      this.totalFiles = _data["totalFiles"];
      this.successFiles = _data["successFiles"];
      this.failedFiles = _data["failedFiles"];
      this.pendingFiles = _data["pendingFiles"];
    }
  }

  static fromJS(data: any): OutgoingWebhookJobRunBody {
    data = typeof data === 'object' ? data : {};
    let result = new OutgoingWebhookJobRunBody();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["jobRunId"] = this.jobRunId;
    data["status"] = this.status;
    data["errorMessage"] = this.errorMessage;
    data["errorCode"] = this.errorCode;
    data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
    data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
    data["totalFiles"] = this.totalFiles;
    data["successFiles"] = this.successFiles;
    data["failedFiles"] = this.failedFiles;
    data["pendingFiles"] = this.pendingFiles;
    return data;
  }
}

export interface IOutgoingWebhookJobRunBody {
  jobRunId?: string;
  status?: JobRunStatusType;
  errorMessage?: string | undefined;
  errorCode?: number | undefined;
  startTime?: Date;
  endTime?: Date;
  totalFiles?: number;
  successFiles?: number;
  failedFiles?: number;
  pendingFiles?: number;
}

export class OutgoingWebhookJobRunItemBody implements IOutgoingWebhookJobRunItemBody {
  jobRunItemId?: string;
  status?: JobRunItemStatusType;
  fileId?: string;
  fileName?: string;
  errorMessage?: string | undefined;
  errorCode?: number | undefined;

  constructor(data?: IOutgoingWebhookJobRunItemBody) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.jobRunItemId = _data["jobRunItemId"];
      this.status = _data["status"];
      this.fileId = _data["fileId"];
      this.fileName = _data["fileName"];
      this.errorMessage = _data["errorMessage"];
      this.errorCode = _data["errorCode"];
    }
  }

  static fromJS(data: any): OutgoingWebhookJobRunItemBody {
    data = typeof data === 'object' ? data : {};
    let result = new OutgoingWebhookJobRunItemBody();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["jobRunItemId"] = this.jobRunItemId;
    data["status"] = this.status;
    data["fileId"] = this.fileId;
    data["fileName"] = this.fileName;
    data["errorMessage"] = this.errorMessage;
    data["errorCode"] = this.errorCode;
    return data;
  }
}

export interface IOutgoingWebhookJobRunItemBody {
  jobRunItemId?: string;
  status?: JobRunItemStatusType;
  fileId?: string;
  fileName?: string;
  errorMessage?: string | undefined;
  errorCode?: number | undefined;
}

export class ZipEntryDto implements IZipEntryDto {
  filename?: string;
  size?: number;
  offset?: number;
  time?: Date;

  constructor(data?: IZipEntryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.filename = _data["filename"];
      this.size = _data["size"];
      this.offset = _data["offset"];
      this.time = _data["time"] ? new Date(_data["time"].toString()) : undefined as any;
    }
  }

  static fromJS(data: any): ZipEntryDto {
    data = typeof data === 'object' ? data : {};
    let result = new ZipEntryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["filename"] = this.filename;
    data["size"] = this.size;
    data["offset"] = this.offset;
    data["time"] = this.time ? this.time.toISOString() : undefined as any;
    return data;
  }
}

export interface IZipEntryDto {
  filename?: string;
  size?: number;
  offset?: number;
  time?: Date;
}

export class StartExtractResponse implements IStartExtractResponse {
  statusCode?: number;
  jobId?: string | undefined;
  filename?: string | undefined;
  objectId?: string | undefined;
  directoryId?: string | undefined;
  userId?: string | undefined;
  retryNumber?: number;

  constructor(data?: IStartExtractResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.statusCode = _data["statusCode"];
      this.jobId = _data["jobId"];
      this.filename = _data["filename"];
      this.objectId = _data["objectId"];
      this.directoryId = _data["directoryId"];
      this.userId = _data["userId"];
      this.retryNumber = _data["retryNumber"];
    }
  }

  static fromJS(data: any): StartExtractResponse {
    data = typeof data === 'object' ? data : {};
    let result = new StartExtractResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["statusCode"] = this.statusCode;
    data["jobId"] = this.jobId;
    data["filename"] = this.filename;
    data["objectId"] = this.objectId;
    data["directoryId"] = this.directoryId;
    data["userId"] = this.userId;
    data["retryNumber"] = this.retryNumber;
    return data;
  }
}

export interface IStartExtractResponse {
  statusCode?: number;
  jobId?: string | undefined;
  filename?: string | undefined;
  objectId?: string | undefined;
  directoryId?: string | undefined;
  userId?: string | undefined;
  retryNumber?: number;
}

export class StartExtractRequest implements IStartExtractRequest {
  sourceFile?: FileDto;
  locationType?: ExtractLocationType;
  destinationNamingType?: FileDestinationNamingType;
  singleFilename?: string | undefined;
  singleFiles?: string[];
  extractDirectory?: DirectoryDto | undefined;
  compositeExtractType?: CompositeExtractType;
  compositeRenamingType?: CompositeRenamingType;

  constructor(data?: IStartExtractRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.sourceFile = _data["sourceFile"] ? FileDto.fromJS(_data["sourceFile"]) : undefined as any;
      this.locationType = _data["locationType"];
      this.destinationNamingType = _data["destinationNamingType"];
      this.singleFilename = _data["singleFilename"];
      if (Array.isArray(_data["singleFiles"])) {
        this.singleFiles = [] as any;
        for (let item of _data["singleFiles"])
          this.singleFiles!.push(item);
      }
      this.extractDirectory = _data["extractDirectory"] ? DirectoryDto.fromJS(_data["extractDirectory"]) : undefined as any;
      this.compositeExtractType = _data["compositeExtractType"];
      this.compositeRenamingType = _data["compositeRenamingType"];
    }
  }

  static fromJS(data: any): StartExtractRequest {
    data = typeof data === 'object' ? data : {};
    let result = new StartExtractRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["sourceFile"] = this.sourceFile ? this.sourceFile.toJSON() : undefined as any;
    data["locationType"] = this.locationType;
    data["destinationNamingType"] = this.destinationNamingType;
    data["singleFilename"] = this.singleFilename;
    if (Array.isArray(this.singleFiles)) {
      data["singleFiles"] = [];
      for (let item of this.singleFiles)
        data["singleFiles"].push(item);
    }
    data["extractDirectory"] = this.extractDirectory ? this.extractDirectory.toJSON() : undefined as any;
    data["compositeExtractType"] = this.compositeExtractType;
    data["compositeRenamingType"] = this.compositeRenamingType;
    return data;
  }
}

export interface IStartExtractRequest {
  sourceFile?: FileDto;
  locationType?: ExtractLocationType;
  destinationNamingType?: FileDestinationNamingType;
  singleFilename?: string | undefined;
  singleFiles?: string[];
  extractDirectory?: DirectoryDto | undefined;
  compositeExtractType?: CompositeExtractType;
  compositeRenamingType?: CompositeRenamingType;
}

export class FileStatus implements IFileStatus {
  id?: string;
  filename?: string;
  downloadUrl?: string;
  extractLocationType?: ExtractLocationType;
  status?: JobRunItemStatusType;
  messages?: string[];

  constructor(data?: IFileStatus) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.filename = _data["filename"];
      this.downloadUrl = _data["downloadUrl"];
      this.extractLocationType = _data["extractLocationType"];
      this.status = _data["status"];
      if (Array.isArray(_data["messages"])) {
        this.messages = [] as any;
        for (let item of _data["messages"])
          this.messages!.push(item);
      }
    }
  }

  static fromJS(data: any): FileStatus {
    data = typeof data === 'object' ? data : {};
    let result = new FileStatus();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["filename"] = this.filename;
    data["downloadUrl"] = this.downloadUrl;
    data["extractLocationType"] = this.extractLocationType;
    data["status"] = this.status;
    if (Array.isArray(this.messages)) {
      data["messages"] = [];
      for (let item of this.messages)
        data["messages"].push(item);
    }
    return data;
  }
}

export interface IFileStatus {
  id?: string;
  filename?: string;
  downloadUrl?: string;
  extractLocationType?: ExtractLocationType;
  status?: JobRunItemStatusType;
  messages?: string[];
}

export class CreateCustomerRequest implements ICreateCustomerRequest {
  emailDomain?: string;
  name?: string;
  validEmails?: string[];
  allowAllUsers?: boolean;

  constructor(data?: ICreateCustomerRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.emailDomain = _data["emailDomain"];
      this.name = _data["name"];
      if (Array.isArray(_data["validEmails"])) {
        this.validEmails = [] as any;
        for (let item of _data["validEmails"])
          this.validEmails!.push(item);
      }
      this.allowAllUsers = _data["allowAllUsers"];
    }
  }

  static fromJS(data: any): CreateCustomerRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateCustomerRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["emailDomain"] = this.emailDomain;
    data["name"] = this.name;
    if (Array.isArray(this.validEmails)) {
      data["validEmails"] = [];
      for (let item of this.validEmails)
        data["validEmails"].push(item);
    }
    data["allowAllUsers"] = this.allowAllUsers;
    return data;
  }
}

export interface ICreateCustomerRequest {
  emailDomain?: string;
  name?: string;
  validEmails?: string[];
  allowAllUsers?: boolean;
}

export class EditCustomerRequest implements IEditCustomerRequest {
  name?: string | undefined;
  addValidEmails?: string[];
  removeValidEmails?: string[];
  allowAllUsers?: boolean | undefined;

  constructor(data?: IEditCustomerRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      if (Array.isArray(_data["addValidEmails"])) {
        this.addValidEmails = [] as any;
        for (let item of _data["addValidEmails"])
          this.addValidEmails!.push(item);
      }
      if (Array.isArray(_data["removeValidEmails"])) {
        this.removeValidEmails = [] as any;
        for (let item of _data["removeValidEmails"])
          this.removeValidEmails!.push(item);
      }
      this.allowAllUsers = _data["allowAllUsers"];
    }
  }

  static fromJS(data: any): EditCustomerRequest {
    data = typeof data === 'object' ? data : {};
    let result = new EditCustomerRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name;
    if (Array.isArray(this.addValidEmails)) {
      data["addValidEmails"] = [];
      for (let item of this.addValidEmails)
        data["addValidEmails"].push(item);
    }
    if (Array.isArray(this.removeValidEmails)) {
      data["removeValidEmails"] = [];
      for (let item of this.removeValidEmails)
        data["removeValidEmails"].push(item);
    }
    data["allowAllUsers"] = this.allowAllUsers;
    return data;
  }
}

export interface IEditCustomerRequest {
  name?: string | undefined;
  addValidEmails?: string[];
  removeValidEmails?: string[];
  allowAllUsers?: boolean | undefined;
}

export class HealthStatus implements IHealthStatus {
  assemblyVersion?: string | undefined;
  fileVersion?: string | undefined;
  productVersion?: string | undefined;
  buildDateTime?: Date;
  requestDate?: Date;

  constructor(data?: IHealthStatus) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.assemblyVersion = _data["assemblyVersion"];
      this.fileVersion = _data["fileVersion"];
      this.productVersion = _data["productVersion"];
      this.buildDateTime = _data["buildDateTime"] ? new Date(_data["buildDateTime"].toString()) : undefined as any;
      this.requestDate = _data["requestDate"] ? new Date(_data["requestDate"].toString()) : undefined as any;
    }
  }

  static fromJS(data: any): HealthStatus {
    data = typeof data === 'object' ? data : {};
    let result = new HealthStatus();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["assemblyVersion"] = this.assemblyVersion;
    data["fileVersion"] = this.fileVersion;
    data["productVersion"] = this.productVersion;
    data["buildDateTime"] = this.buildDateTime ? this.buildDateTime.toISOString() : undefined as any;
    data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : undefined as any;
    return data;
  }
}

export interface IHealthStatus {
  assemblyVersion?: string | undefined;
  fileVersion?: string | undefined;
  productVersion?: string | undefined;
  buildDateTime?: Date;
  requestDate?: Date;
}

export class Project implements IProject {
  hubId?: string;
  hubName?: string;
  hubRegion?: string;
  hubType?: HubType;
  id?: string;
  name?: string;
  rootDirectoryId?: string | undefined;
  imageUrl?: string | undefined;
  projectType?: ProjectType;
  scopes?: string[];
  isBim360Project?: boolean;
  revitVersion?: string | undefined;

  constructor(data?: IProject) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.hubId = _data["hubId"];
      this.hubName = _data["hubName"];
      this.hubRegion = _data["hubRegion"];
      this.hubType = _data["hubType"];
      this.id = _data["id"];
      this.name = _data["name"];
      this.rootDirectoryId = _data["rootDirectoryId"];
      this.imageUrl = _data["imageUrl"];
      this.projectType = _data["projectType"];
      if (Array.isArray(_data["scopes"])) {
        this.scopes = [] as any;
        for (let item of _data["scopes"])
          this.scopes!.push(item);
      }
      this.isBim360Project = _data["isBim360Project"];
      this.revitVersion = _data["revitVersion"];
    }
  }

  static fromJS(data: any): Project {
    data = typeof data === 'object' ? data : {};
    let result = new Project();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["hubId"] = this.hubId;
    data["hubName"] = this.hubName;
    data["hubRegion"] = this.hubRegion;
    data["hubType"] = this.hubType;
    data["id"] = this.id;
    data["name"] = this.name;
    data["rootDirectoryId"] = this.rootDirectoryId;
    data["imageUrl"] = this.imageUrl;
    data["projectType"] = this.projectType;
    if (Array.isArray(this.scopes)) {
      data["scopes"] = [];
      for (let item of this.scopes)
        data["scopes"].push(item);
    }
    data["isBim360Project"] = this.isBim360Project;
    data["revitVersion"] = this.revitVersion;
    return data;
  }
}

export interface IProject {
  hubId?: string;
  hubName?: string;
  hubRegion?: string;
  hubType?: HubType;
  id?: string;
  name?: string;
  rootDirectoryId?: string | undefined;
  imageUrl?: string | undefined;
  projectType?: ProjectType;
  scopes?: string[];
  isBim360Project?: boolean;
  revitVersion?: string | undefined;
}

export class ProjectRevitVersionDetectionResult implements IProjectRevitVersionDetectionResult {
  id?: string | undefined;
  hubId?: string | undefined;
  projectId?: string | undefined;
  revitProjectVersion?: string | undefined;
  isDone?: boolean;
  errorMessage?: string | undefined;
  searchMaxPages?: boolean;

  constructor(data?: IProjectRevitVersionDetectionResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.hubId = _data["hubId"];
      this.projectId = _data["projectId"];
      this.revitProjectVersion = _data["revitProjectVersion"];
      this.isDone = _data["isDone"];
      this.errorMessage = _data["errorMessage"];
      this.searchMaxPages = _data["searchMaxPages"];
    }
  }

  static fromJS(data: any): ProjectRevitVersionDetectionResult {
    data = typeof data === 'object' ? data : {};
    let result = new ProjectRevitVersionDetectionResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["hubId"] = this.hubId;
    data["projectId"] = this.projectId;
    data["revitProjectVersion"] = this.revitProjectVersion;
    data["isDone"] = this.isDone;
    data["errorMessage"] = this.errorMessage;
    data["searchMaxPages"] = this.searchMaxPages;
    return data;
  }
}

export interface IProjectRevitVersionDetectionResult {
  id?: string | undefined;
  hubId?: string | undefined;
  projectId?: string | undefined;
  revitProjectVersion?: string | undefined;
  isDone?: boolean;
  errorMessage?: string | undefined;
  searchMaxPages?: boolean;
}

export class GetRvtVersionResponse implements IGetRvtVersionResponse {
  rvtVersion?: string | undefined;

  constructor(data?: IGetRvtVersionResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.rvtVersion = _data["rvtVersion"];
    }
  }

  static fromJS(data: any): GetRvtVersionResponse {
    data = typeof data === 'object' ? data : {};
    let result = new GetRvtVersionResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["rvtVersion"] = this.rvtVersion;
    return data;
  }
}

export interface IGetRvtVersionResponse {
  rvtVersion?: string | undefined;
}

export class Hub implements IHub {
  id?: string;
  name?: string;
  region?: string;
  hubType?: HubType;

  constructor(data?: IHub) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.region = _data["region"];
      this.hubType = _data["hubType"];
    }
  }

  static fromJS(data: any): Hub {
    data = typeof data === 'object' ? data : {};
    let result = new Hub();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["region"] = this.region;
    data["hubType"] = this.hubType;
    return data;
  }
}

export interface IHub {
  id?: string;
  name?: string;
  region?: string;
  hubType?: HubType;
}

export class StartProjectRevitVersionDetectionRequest implements IStartProjectRevitVersionDetectionRequest {
  hubId?: string | undefined;
  projectId?: string | undefined;

  constructor(data?: IStartProjectRevitVersionDetectionRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.hubId = _data["hubId"];
      this.projectId = _data["projectId"];
    }
  }

  static fromJS(data: any): StartProjectRevitVersionDetectionRequest {
    data = typeof data === 'object' ? data : {};
    let result = new StartProjectRevitVersionDetectionRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["hubId"] = this.hubId;
    data["projectId"] = this.projectId;
    return data;
  }
}

export interface IStartProjectRevitVersionDetectionRequest {
  hubId?: string | undefined;
  projectId?: string | undefined;
}

export class ProjectWiseConfiguration implements IProjectWiseConfiguration {
  id?: string;
  credentialId?: string;
  serverAddress?: string;
  repositoryId?: string;
  repositoryName?: string;

  constructor(data?: IProjectWiseConfiguration) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.credentialId = _data["credentialId"];
      this.serverAddress = _data["serverAddress"];
      this.repositoryId = _data["repositoryId"];
      this.repositoryName = _data["repositoryName"];
    }
  }

  static fromJS(data: any): ProjectWiseConfiguration {
    data = typeof data === 'object' ? data : {};
    let result = new ProjectWiseConfiguration();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["credentialId"] = this.credentialId;
    data["serverAddress"] = this.serverAddress;
    data["repositoryId"] = this.repositoryId;
    data["repositoryName"] = this.repositoryName;
    return data;
  }
}

export interface IProjectWiseConfiguration {
  id?: string;
  credentialId?: string;
  serverAddress?: string;
  repositoryId?: string;
  repositoryName?: string;
}

export class CreateProjectWiseConfigurationDto implements ICreateProjectWiseConfigurationDto {
  repositoryId?: string;
  serverAddress?: string;
  repositoryName?: string;
  credentialId?: string;

  constructor(data?: ICreateProjectWiseConfigurationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.repositoryId = _data["repositoryId"];
      this.serverAddress = _data["serverAddress"];
      this.repositoryName = _data["repositoryName"];
      this.credentialId = _data["credentialId"];
    }
  }

  static fromJS(data: any): CreateProjectWiseConfigurationDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateProjectWiseConfigurationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["repositoryId"] = this.repositoryId;
    data["serverAddress"] = this.serverAddress;
    data["repositoryName"] = this.repositoryName;
    data["credentialId"] = this.credentialId;
    return data;
  }
}

export interface ICreateProjectWiseConfigurationDto {
  repositoryId?: string;
  serverAddress?: string;
  repositoryName?: string;
  credentialId?: string;
}

export class ProjectWiseCredential implements IProjectWiseCredential {
  id?: string;
  key?: string;
  username?: string;

  constructor(data?: IProjectWiseCredential) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.key = _data["key"];
      this.username = _data["username"];
    }
  }

  static fromJS(data: any): ProjectWiseCredential {
    data = typeof data === 'object' ? data : {};
    let result = new ProjectWiseCredential();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["key"] = this.key;
    data["username"] = this.username;
    return data;
  }
}

export interface IProjectWiseCredential {
  id?: string;
  key?: string;
  username?: string;
}

export class CreateProjectWiseCredentialDto implements ICreateProjectWiseCredentialDto {
  key?: string;
  username?: string;
  password?: string;

  constructor(data?: ICreateProjectWiseCredentialDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.key = _data["key"];
      this.username = _data["username"];
      this.password = _data["password"];
    }
  }

  static fromJS(data: any): CreateProjectWiseCredentialDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateProjectWiseCredentialDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["key"] = this.key;
    data["username"] = this.username;
    data["password"] = this.password;
    return data;
  }
}

export interface ICreateProjectWiseCredentialDto {
  key?: string;
  username?: string;
  password?: string;
}

export class ProjectWiseCredentialWithSecret extends ProjectWiseCredential implements IProjectWiseCredentialWithSecret {
  password?: string;

  constructor(data?: IProjectWiseCredentialWithSecret) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.password = _data["password"];
    }
  }

  static override fromJS(data: any): ProjectWiseCredentialWithSecret {
    data = typeof data === 'object' ? data : {};
    let result = new ProjectWiseCredentialWithSecret();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["password"] = this.password;
    super.toJSON(data);
    return data;
  }
}

export interface IProjectWiseCredentialWithSecret extends IProjectWiseCredential {
  password?: string;
}

export class PaginatedResultOfProjectWiseConfiguration extends PaginatedCount implements IPaginatedResultOfProjectWiseConfiguration {
  items?: ProjectWiseConfiguration[];

  constructor(data?: IPaginatedResultOfProjectWiseConfiguration) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(ProjectWiseConfiguration.fromJS(item));
      }
    }
  }

  static override fromJS(data: any): PaginatedResultOfProjectWiseConfiguration {
    data = typeof data === 'object' ? data : {};
    let result = new PaginatedResultOfProjectWiseConfiguration();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item ? item.toJSON() : undefined as any);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IPaginatedResultOfProjectWiseConfiguration extends IPaginatedCount {
  items?: ProjectWiseConfiguration[];
}

export class ProjectWiseConfigurationPaginatedResult extends PaginatedResultOfProjectWiseConfiguration implements IProjectWiseConfigurationPaginatedResult {

  constructor(data?: IProjectWiseConfigurationPaginatedResult) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): ProjectWiseConfigurationPaginatedResult {
    data = typeof data === 'object' ? data : {};
    let result = new ProjectWiseConfigurationPaginatedResult();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IProjectWiseConfigurationPaginatedResult extends IPaginatedResultOfProjectWiseConfiguration {
}

export class PaginatedResultOfProjectWiseCredential extends PaginatedCount implements IPaginatedResultOfProjectWiseCredential {
  items?: ProjectWiseCredential[];

  constructor(data?: IPaginatedResultOfProjectWiseCredential) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(ProjectWiseCredential.fromJS(item));
      }
    }
  }

  static override fromJS(data: any): PaginatedResultOfProjectWiseCredential {
    data = typeof data === 'object' ? data : {};
    let result = new PaginatedResultOfProjectWiseCredential();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item ? item.toJSON() : undefined as any);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IPaginatedResultOfProjectWiseCredential extends IPaginatedCount {
  items?: ProjectWiseCredential[];
}

export class ProjectWiseCredentialPaginatedResult extends PaginatedResultOfProjectWiseCredential implements IProjectWiseCredentialPaginatedResult {

  constructor(data?: IProjectWiseCredentialPaginatedResult) {
    super(data);
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): ProjectWiseCredentialPaginatedResult {
    data = typeof data === 'object' ? data : {};
    let result = new ProjectWiseCredentialPaginatedResult();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IProjectWiseCredentialPaginatedResult extends IPaginatedResultOfProjectWiseCredential {
}

export class UpdateProjectWiseConfigurationDto implements IUpdateProjectWiseConfigurationDto {
  repositoryId?: string | undefined;
  credentialId?: string | undefined;
  serverAddress?: string | undefined;
  repositoryName?: string | undefined;

  constructor(data?: IUpdateProjectWiseConfigurationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.repositoryId = _data["repositoryId"];
      this.credentialId = _data["credentialId"];
      this.serverAddress = _data["serverAddress"];
      this.repositoryName = _data["repositoryName"];
    }
  }

  static fromJS(data: any): UpdateProjectWiseConfigurationDto {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateProjectWiseConfigurationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["repositoryId"] = this.repositoryId;
    data["credentialId"] = this.credentialId;
    data["serverAddress"] = this.serverAddress;
    data["repositoryName"] = this.repositoryName;
    return data;
  }
}

export interface IUpdateProjectWiseConfigurationDto {
  repositoryId?: string | undefined;
  credentialId?: string | undefined;
  serverAddress?: string | undefined;
  repositoryName?: string | undefined;
}

export class UpdateProjectWiseCredentialDto implements IUpdateProjectWiseCredentialDto {
  key?: string | undefined;
  username?: string | undefined;
  password?: string | undefined;

  constructor(data?: IUpdateProjectWiseCredentialDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.key = _data["key"];
      this.username = _data["username"];
      this.password = _data["password"];
    }
  }

  static fromJS(data: any): UpdateProjectWiseCredentialDto {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateProjectWiseCredentialDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["key"] = this.key;
    data["username"] = this.username;
    data["password"] = this.password;
    return data;
  }
}

export interface IUpdateProjectWiseCredentialDto {
  key?: string | undefined;
  username?: string | undefined;
  password?: string | undefined;
}

export class UserAccount implements IUserAccount {
  id?: string;
  isTeam?: boolean;

  constructor(data?: IUserAccount) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.isTeam = _data["isTeam"];
    }
  }

  static fromJS(data: any): UserAccount {
    data = typeof data === 'object' ? data : {};
    let result = new UserAccount();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["isTeam"] = this.isTeam;
    return data;
  }
}

export interface IUserAccount {
  id?: string;
  isTeam?: boolean;
}

export class GDPRWebhookResponse implements IGDPRWebhookResponse {
  taskId?: string;
  status?: GDPRWebhookResponseStatus;
  description?: string | undefined;

  constructor(data?: IGDPRWebhookResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.taskId = _data["taskId"];
      this.status = _data["status"] ? GDPRWebhookResponseStatus.fromJS(_data["status"]) : undefined as any;
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): GDPRWebhookResponse {
    data = typeof data === 'object' ? data : {};
    let result = new GDPRWebhookResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["taskId"] = this.taskId;
    data["status"] = this.status ? this.status.toJSON() : undefined as any;
    data["description"] = this.description;
    return data;
  }
}

export interface IGDPRWebhookResponse {
  taskId?: string;
  status?: GDPRWebhookResponseStatus;
  description?: string | undefined;
}

export class GDPRWebhookResponseStatus implements IGDPRWebhookResponseStatus {
  code?: string;
  type?: string | undefined;
  userType?: string | undefined;
  reason?: string | undefined;

  constructor(data?: IGDPRWebhookResponseStatus) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.code = _data["code"];
      this.type = _data["type"];
      this.userType = _data["userType"];
      this.reason = _data["reason"];
    }
  }

  static fromJS(data: any): GDPRWebhookResponseStatus {
    data = typeof data === 'object' ? data : {};
    let result = new GDPRWebhookResponseStatus();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["code"] = this.code;
    data["type"] = this.type;
    data["userType"] = this.userType;
    data["reason"] = this.reason;
    return data;
  }
}

export interface IGDPRWebhookResponseStatus {
  code?: string;
  type?: string | undefined;
  userType?: string | undefined;
  reason?: string | undefined;
}

export class GDPRWebhook implements IGDPRWebhook {
  version?: number | undefined;
  hook?: GDPRHook;
  payload?: GDPRWebhookPayload;

  constructor(data?: IGDPRWebhook) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.version = _data["version"];
      this.hook = _data["hook"] ? GDPRHook.fromJS(_data["hook"]) : undefined as any;
      this.payload = _data["payload"] ? GDPRWebhookPayload.fromJS(_data["payload"]) : undefined as any;
    }
  }

  static fromJS(data: any): GDPRWebhook {
    data = typeof data === 'object' ? data : {};
    let result = new GDPRWebhook();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["version"] = this.version;
    data["hook"] = this.hook ? this.hook.toJSON() : undefined as any;
    data["payload"] = this.payload ? this.payload.toJSON() : undefined as any;
    return data;
  }
}

export interface IGDPRWebhook {
  version?: number | undefined;
  hook?: GDPRHook;
  payload?: GDPRWebhookPayload;
}

export class GDPRHook implements IGDPRHook {
  eventType?: string;
  hookId?: string;
  clientID?: string;
  webhookEndPoint?: string;
  createdDate?: string;

  constructor(data?: IGDPRHook) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.eventType = _data["eventType"];
      this.hookId = _data["hookId"];
      this.clientID = _data["clientID"];
      this.webhookEndPoint = _data["webhookEndPoint"];
      this.createdDate = _data["createdDate"];
    }
  }

  static fromJS(data: any): GDPRHook {
    data = typeof data === 'object' ? data : {};
    let result = new GDPRHook();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["eventType"] = this.eventType;
    data["hookId"] = this.hookId;
    data["clientID"] = this.clientID;
    data["webhookEndPoint"] = this.webhookEndPoint;
    data["createdDate"] = this.createdDate;
    return data;
  }
}

export interface IGDPRHook {
  eventType?: string;
  hookId?: string;
  clientID?: string;
  webhookEndPoint?: string;
  createdDate?: string;
}

export class GDPRWebhookPayload implements IGDPRWebhookPayload {
  version?: number | undefined;
  taskId?: string;
  user_info?: GDPRWebhookUserInfo;
  callbackUrl?: string;
  respondBy?: number | undefined;
  status?: string;

  constructor(data?: IGDPRWebhookPayload) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.version = _data["version"];
      this.taskId = _data["taskId"];
      this.user_info = _data["user_info"] ? GDPRWebhookUserInfo.fromJS(_data["user_info"]) : undefined as any;
      this.callbackUrl = _data["callbackUrl"];
      this.respondBy = _data["respondBy"];
      this.status = _data["status"];
    }
  }

  static fromJS(data: any): GDPRWebhookPayload {
    data = typeof data === 'object' ? data : {};
    let result = new GDPRWebhookPayload();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["version"] = this.version;
    data["taskId"] = this.taskId;
    data["user_info"] = this.user_info ? this.user_info.toJSON() : undefined as any;
    data["callbackUrl"] = this.callbackUrl;
    data["respondBy"] = this.respondBy;
    data["status"] = this.status;
    return data;
  }
}

export interface IGDPRWebhookPayload {
  version?: number | undefined;
  taskId?: string;
  user_info?: GDPRWebhookUserInfo;
  callbackUrl?: string;
  respondBy?: number | undefined;
  status?: string;
}

export class GDPRWebhookUserInfo implements IGDPRWebhookUserInfo {
  id?: string | undefined;
  email?: string;
  name?: string;
  user_type?: string | undefined;

  constructor(data?: IGDPRWebhookUserInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.email = _data["email"];
      this.name = _data["name"];
      this.user_type = _data["user_type"];
    }
  }

  static fromJS(data: any): GDPRWebhookUserInfo {
    data = typeof data === 'object' ? data : {};
    let result = new GDPRWebhookUserInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    data["email"] = this.email;
    data["name"] = this.name;
    data["user_type"] = this.user_type;
    return data;
  }
}

export interface IGDPRWebhookUserInfo {
  id?: string | undefined;
  email?: string;
  name?: string;
  user_type?: string | undefined;
}

export class WebhookBody implements IWebhookBody {
  version?: string | undefined;
  resourceUrn?: string | undefined;
  hook?: Hook | undefined;
  payload?: WebhookPayload | undefined;

  constructor(data?: IWebhookBody) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.version = _data["version"];
      this.resourceUrn = _data["resourceUrn"];
      this.hook = _data["hook"] ? Hook.fromJS(_data["hook"]) : undefined as any;
      this.payload = _data["payload"] ? WebhookPayload.fromJS(_data["payload"]) : undefined as any;
    }
  }

  static fromJS(data: any): WebhookBody {
    data = typeof data === 'object' ? data : {};
    let result = new WebhookBody();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["version"] = this.version;
    data["resourceUrn"] = this.resourceUrn;
    data["hook"] = this.hook ? this.hook.toJSON() : undefined as any;
    data["payload"] = this.payload ? this.payload.toJSON() : undefined as any;
    return data;
  }
}

export interface IWebhookBody {
  version?: string | undefined;
  resourceUrn?: string | undefined;
  hook?: Hook | undefined;
  payload?: WebhookPayload | undefined;
}

export class Hook implements IHook {
  hookId?: string | undefined;
  tenant?: string | undefined;
  callbackUrl?: string | undefined;
  createdBy?: string | undefined;
  event?: string | undefined;
  createdDate?: Date;
  system?: string | undefined;
  creatorType?: string | undefined;
  status?: string | undefined;
  scope?: Scope | undefined;
  urn?: string | undefined;
  filter?: string | undefined;
  projectId?: string | undefined;
  hubId?: string | undefined;
  autoReactivateHook?: boolean;
  hookAttribute?: { [key: string]: any; } | undefined;
  __self__?: string | undefined;

  constructor(data?: IHook) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.hookId = _data["hookId"];
      this.tenant = _data["tenant"];
      this.callbackUrl = _data["callbackUrl"];
      this.createdBy = _data["createdBy"];
      this.event = _data["event"];
      this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
      this.system = _data["system"];
      this.creatorType = _data["creatorType"];
      this.status = _data["status"];
      this.scope = _data["scope"] ? Scope.fromJS(_data["scope"]) : undefined as any;
      this.urn = _data["urn"];
      this.filter = _data["filter"];
      this.projectId = _data["projectId"];
      this.hubId = _data["hubId"];
      this.autoReactivateHook = _data["autoReactivateHook"];
      if (_data["hookAttribute"]) {
        this.hookAttribute = {} as any;
        for (let key in _data["hookAttribute"]) {
          if (_data["hookAttribute"].hasOwnProperty(key))
            (this.hookAttribute as any)![key] = _data["hookAttribute"][key];
        }
      }
      this.__self__ = _data["__self__"];
    }
  }

  static fromJS(data: any): Hook {
    data = typeof data === 'object' ? data : {};
    let result = new Hook();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["hookId"] = this.hookId;
    data["tenant"] = this.tenant;
    data["callbackUrl"] = this.callbackUrl;
    data["createdBy"] = this.createdBy;
    data["event"] = this.event;
    data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
    data["system"] = this.system;
    data["creatorType"] = this.creatorType;
    data["status"] = this.status;
    data["scope"] = this.scope ? this.scope.toJSON() : undefined as any;
    data["urn"] = this.urn;
    data["filter"] = this.filter;
    data["projectId"] = this.projectId;
    data["hubId"] = this.hubId;
    data["autoReactivateHook"] = this.autoReactivateHook;
    if (this.hookAttribute) {
      data["hookAttribute"] = {};
      for (let key in this.hookAttribute) {
        if (this.hookAttribute.hasOwnProperty(key))
          (data["hookAttribute"] as any)[key] = (this.hookAttribute as any)[key];
      }
    }
    data["__self__"] = this.__self__;
    return data;
  }
}

export interface IHook {
  hookId?: string | undefined;
  tenant?: string | undefined;
  callbackUrl?: string | undefined;
  createdBy?: string | undefined;
  event?: string | undefined;
  createdDate?: Date;
  system?: string | undefined;
  creatorType?: string | undefined;
  status?: string | undefined;
  scope?: Scope | undefined;
  urn?: string | undefined;
  filter?: string | undefined;
  projectId?: string | undefined;
  hubId?: string | undefined;
  autoReactivateHook?: boolean;
  hookAttribute?: { [key: string]: any; } | undefined;
  __self__?: string | undefined;
}

export class Scope implements IScope {
  folder?: string | undefined;

  constructor(data?: IScope) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.folder = _data["folder"];
    }
  }

  static fromJS(data: any): Scope {
    data = typeof data === 'object' ? data : {};
    let result = new Scope();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["folder"] = this.folder;
    return data;
  }
}

export interface IScope {
  folder?: string | undefined;
}

export class WebhookPayload implements IWebhookPayload {
  ext?: string | undefined;
  modifiedTime?: string | undefined;
  creator?: string | undefined;
  lineageUrn?: string | undefined;
  sizeInBytes?: number;
  hidden?: boolean;
  indexable?: boolean;
  project?: string | undefined;
  source?: string | undefined;
  version?: string | undefined;
  user_info?: UserInfo | undefined;
  name?: string | undefined;
  createdTime?: string | undefined;
  modifiedBy?: string | undefined;
  state?: string | undefined;
  parentFolderUrn?: string | undefined;
  ancestors?: Ancestor[] | undefined;
  tenant?: string | undefined;

  constructor(data?: IWebhookPayload) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.ext = _data["ext"];
      this.modifiedTime = _data["modifiedTime"];
      this.creator = _data["creator"];
      this.lineageUrn = _data["lineageUrn"];
      this.sizeInBytes = _data["sizeInBytes"];
      this.hidden = _data["hidden"];
      this.indexable = _data["indexable"];
      this.project = _data["project"];
      this.source = _data["source"];
      this.version = _data["version"];
      this.user_info = _data["user_info"] ? UserInfo.fromJS(_data["user_info"]) : undefined as any;
      this.name = _data["name"];
      this.createdTime = _data["createdTime"];
      this.modifiedBy = _data["modifiedBy"];
      this.state = _data["state"];
      this.parentFolderUrn = _data["parentFolderUrn"];
      if (Array.isArray(_data["ancestors"])) {
        this.ancestors = [] as any;
        for (let item of _data["ancestors"])
          this.ancestors!.push(Ancestor.fromJS(item));
      }
      this.tenant = _data["tenant"];
    }
  }

  static fromJS(data: any): WebhookPayload {
    data = typeof data === 'object' ? data : {};
    let result = new WebhookPayload();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["ext"] = this.ext;
    data["modifiedTime"] = this.modifiedTime;
    data["creator"] = this.creator;
    data["lineageUrn"] = this.lineageUrn;
    data["sizeInBytes"] = this.sizeInBytes;
    data["hidden"] = this.hidden;
    data["indexable"] = this.indexable;
    data["project"] = this.project;
    data["source"] = this.source;
    data["version"] = this.version;
    data["user_info"] = this.user_info ? this.user_info.toJSON() : undefined as any;
    data["name"] = this.name;
    data["createdTime"] = this.createdTime;
    data["modifiedBy"] = this.modifiedBy;
    data["state"] = this.state;
    data["parentFolderUrn"] = this.parentFolderUrn;
    if (Array.isArray(this.ancestors)) {
      data["ancestors"] = [];
      for (let item of this.ancestors)
        data["ancestors"].push(item ? item.toJSON() : undefined as any);
    }
    data["tenant"] = this.tenant;
    return data;
  }
}

export interface IWebhookPayload {
  ext?: string | undefined;
  modifiedTime?: string | undefined;
  creator?: string | undefined;
  lineageUrn?: string | undefined;
  sizeInBytes?: number;
  hidden?: boolean;
  indexable?: boolean;
  project?: string | undefined;
  source?: string | undefined;
  version?: string | undefined;
  user_info?: UserInfo | undefined;
  name?: string | undefined;
  createdTime?: string | undefined;
  modifiedBy?: string | undefined;
  state?: string | undefined;
  parentFolderUrn?: string | undefined;
  ancestors?: Ancestor[] | undefined;
  tenant?: string | undefined;
}

export class UserInfo implements IUserInfo {
  id?: string | undefined;

  constructor(data?: IUserInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): UserInfo {
    data = typeof data === 'object' ? data : {};
    let result = new UserInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id;
    return data;
  }
}

export interface IUserInfo {
  id?: string | undefined;
}

export class Ancestor implements IAncestor {
  urn?: string | undefined;
  name?: string | undefined;

  constructor(data?: IAncestor) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.urn = _data["urn"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): Ancestor {
    data = typeof data === 'object' ? data : {};
    let result = new Ancestor();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["urn"] = this.urn;
    data["name"] = this.name;
    return data;
  }
}

export interface IAncestor {
  urn?: string | undefined;
  name?: string | undefined;
}